<template>
<div>
     <div class="custom-loader-wrapper" v-if="download_loader">
        <div class="text-center">
            <span class="d-block max-450">{{download_text}}</span>
            <img v-bind:src="$api_url+'/public/images/download-loader.svg'" class="loader-logo" width="100px"/>
            <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
            <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>   
        </div> 
    </div>
    <div class="row">
        <div class="col-md-10 col-sm-12" >
            <h4 class="atlhr-dashboard-title mt-10"><template v-if="fdata.status != '1'">Draft </template><template v-else>Approved </template> {{fdata.name}} <b-icon v-if="fdata.status == '1'" icon="check-circle-fill" class="ml-2" variant="success"></b-icon><span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard </a>/ Gratuity Fund Run Details </span></h4>
        </div>
    </div>
    <div class="" v-if="payslipids.length > 0">Selected Employee(s): {{payslipids.length}}</div>
  <div class="card mt-0 border-0 bg-wash no-shadow trz_custom_ppl_count">
  <div v-if="modalsuccess != ''" class="alert alert-success" role="alert"> {{modalsuccess}} </div>
  
              <div class="card-header px-0 bg-transparent border-0">
                <div class="row no-margin">
                    <div class="col-sm-8 pl-0" >
                        <div class="employee-btn-holder">
                            <b-button  class="mb-1"  :href="pgurl+'/gratuity-fund-runs/'"><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="1"></b-icon> Back to List</b-button>
                            <!-- 
                            <b-dropdown v-if="fdata.status != '1'"  text="Export/Import" class="trz-custom-dropdown mb-1">
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item @click="exportAll"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Export Payroll Run</b-dropdown-item>
                                </b-dropdown-group>
                            <b-dropdown-divider></b-dropdown-divider>
                                
                            <b-form-file id="datafile" name="datafile" style="display: none" @change="uploadFile"  accept=".xlsx,.xls"></b-form-file>
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item v-if="fdata.status != '1'" @click="importAll"><b-icon icon="box-arrow-up" class="mr-2" scale="1"></b-icon>Import and Process Excel</b-dropdown-item>
                                </b-dropdown-group>
                            </b-dropdown>
                            -->
                            <b-dropdown text="Downloads" class="trz-custom-dropdown mb-1">
                                <!--<b-dropdown-group id="dropdown-group-1" header="Payroll">
                                    <b-dropdown-item @click="getSalaryReport(fdata.year,fdata.mn)" v-if="fdata.status == '0'"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Draft Payroll Report</b-dropdown-item>
                                    <b-dropdown-item :href="pgurl+'/payroll_monthly_report?year='+fdata.year+'&month='+fdata.mn+'&grid_report=Excel'" v-if="fdata.status == '1'"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Approved Payroll Report</b-dropdown-item>
                                    <b-dropdown-item @click="downloadBankfile()"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Bank File</b-dropdown-item>
                                </b-dropdown-group>
                                
                                
                                <b-dropdown-divider></b-dropdown-divider>-->
                                <b-dropdown-group id="dropdown-group-1" header="GF Slips">
                                    <b-dropdown-item  @click="downloadPayslips()"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Download Selected</b-dropdown-item>
                                    <b-dropdown-item  @click="downloadAllPayslips()"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Download All</b-dropdown-item>
                                </b-dropdown-group>
                                
                                <!--<b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Taxcards">
                                    <b-dropdown-item @click="downloadTaxcards()"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Download Selected</b-dropdown-item>
                                    <b-dropdown-item @click="downloadAllTaxcards()"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Download All</b-dropdown-item>
                                </b-dropdown-group>-->
               
               
                                
                                
                                <!--<b-dropdown-divider v-if="fdata.parent==0 && fdata.status == '1'"></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item  @click="downloadBankfile()" v-if="fdata.parent==0 && fdata.status == '1'"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Download Bank File</b-dropdown-item>
                                </b-dropdown-group>-->
                            </b-dropdown>
                            <b-dropdown v-if="fdata.status != '1'"  text=" Gratuity Fund Run Settings" class="trz-custom-dropdown mb-1">
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item @click="modifyPayslips(1)">Reset Gratuity Fund Slip</b-dropdown-item>
                                </b-dropdown-group>
                                
                                <b-dropdown-divider></b-dropdown-divider>
                                
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item @click="modifyPayslips(2)">Delete  Gratuity Fund Slip</b-dropdown-item>
                                </b-dropdown-group>
                                
                                <b-dropdown-divider></b-dropdown-divider>
                                
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item @click="showDeleteModal(3)">Delete Run</b-dropdown-item>
                                </b-dropdown-group>
        
                            </b-dropdown>
                            <!-- <b-dropdown v-if="fdata.status == '1'"  text="Challans" class="trz-custom-dropdown mb-1">
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item :href="pgurl+'/challans/?payrun_id='+fdata.id+'&month='+fdata.month+'&fiscal_year='+fdata.fiscal_year"><b-icon icon="plus" class="mr-2" scale="1"></b-icon>Create Challan</b-dropdown-item>
                                </b-dropdown-group>
                                
                                <b-dropdown-divider></b-dropdown-divider>
                                
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item  :href="pgurl+'/challans/?payrun_id='+fdata.id+'&month='+fdata.month+'&fiscal_year='+fdata.fiscal_year"><b-icon icon="list" class="mr-2" scale="1"></b-icon>Challan List ({{fdata.total_challans}})</b-dropdown-item>
                                </b-dropdown-group>
        
                            </b-dropdown> -->
                            <!-- <b-dropdown v-if="fdata.status == '1'"  text="Email" class="trz-custom-dropdown mb-1">
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item @click="modifyPayslipsEmail(3)">Email Selected Payslip(s)</b-dropdown-item>
                                </b-dropdown-group>
                                
                                <b-dropdown-divider></b-dropdown-divider>
                                
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item @click="modifyPayslipsEmail(4)">Email Selected Taxcard(s)</b-dropdown-item>
                                </b-dropdown-group>
        
                            </b-dropdown> -->
                            <!--<span v-if="emailing != ''"><img :src="pgurl+'/public/images/loading.gif'" width="20"> We are initiating email sending process. Please wait, this may take few seconds...</span>-->
                        </div>
                        
                    </div>
                    <div class="col-sm-4 pr-0">
                        <div class="col-12 text-right pr-0" :class="">
                            <b-button  class="mb-1"  v-if="fdata.status != '1'"  href="javascript:void(0);" @click="showApproveModal()"><b-icon icon="pencil-square" class="mr-2" scale="1"></b-icon>Approve Gratuity Fund Run</b-button>
                            <span class="btn mb-1" style="color: green !important; border: 1px solid green;" v-if="fdata.status == '1'"  >Approved</span>
                            <b-button  class="mb-1" v-if="fdata.status != '1'" @click="displaynewpayslipmodal(fdata.id)">Create Gratuity Fund Slip</b-button>                            
                        </div>
                    </div>
                </div>              
                <!--<div v-if="emailsuccess != ''" class="alert alert-success" role="alert"> {{emailsuccess}} </div>-->
                <div v-if="emailing != ''" class="alert alert-info" role="alert"><img :src="pgurl+'/public/images/loading.gif'" width="20" class="mr-2"> We are initiating email sending process. Please wait, this may take few seconds... </div>
                <div v-if="emailing_success != ''" class="alert alert-success" role="alert"><b-icon icon="check-circle-fill" class="mr-2" variant="success"></b-icon> {{emailing_success}} </div>
                <div class="col-sm-12 text-center" >
                    

                    
                    

                    


                </div>
                <!--<div class="card-header-inner clearfix mt-3">
                    <div class="float-left align-self-center pt-1 col-sm-3 px-0" style="font-size: 18px;">Total Payslip(s) <span class="ml-2" style="color: #5A8DEE;">{{pagination.total}}</span></div>
                    <div class="float-left align-self-center col-sm-9 custom-search pr-0">
                        <b-input-group >
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search by employee / position / branch / email / phone"  v-model="search.allparams" @input="setSearch()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>-->
            </div>    
  
    
    
     <div><b-modal id="delete-payrun-modal" :title="payrun_delete_msg" hide-footer>Please enter your password to continue:
 <br />
 <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass"> 

 <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div>
 <div style="height: 10px;clear:both;"> &nbsp;</div>
  <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deletePayrun(2)">Delete Run <span v-if="loading != ''"><img :src="pgurl+'/public/images/loading.gif'" width="20"></span></a>
  &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-payrun-modal')">Cancel</a>
  <div style="height: 5px;clear:both;"> &nbsp;</div>
  
 </b-modal></div>
    
    
    
 <div><b-modal id="pass-modal" title="Are you sure to Approve?" hide-footer>All the previous gratuity fund runs/slips will be locked after this process is done.<br>Please enter your password to continue:
 <br />
 
 
 <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass"> 

 <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div>
 <div style="height: 10px;clear:both;"> &nbsp;</div>
  <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="approvePayrun(fdata.id)">Approve <span v-if="loading != ''"><img :src="pgurl+'/public/images/loading.gif'" width="20"></span></a>
  &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('pass-modal')">Cancel</a>
  <div style="height: 5px;clear:both;"> &nbsp;</div>
 </b-modal></div>   

<div>
  <b-modal id="payslip_modal" :title="'Draft Payslip: '+fiscal_year"  size="lg" hide-footer>
  
  
        <div style="margin: 0 30px 30px 30px;">
	        <form @submit="formSubmit" enctype="multipart/form-data">
            <input class="input" type="hidden" v-model="fadatamodal.id" >
			<input class="input" type="hidden" v-model="employee_id" >
			<input class="input" type="hidden" v-model="fiscal_year" >
			<input class="input" type="hidden" v-model="from_date" >
			<input class="input" type="hidden" v-model="to_date" >
			<input class="input" type="hidden" v-model="pay_slip_ref" >
			<input class="input" type="hidden" v-model="pay_slip_name" >
            
            <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'One-off Tax Deduct'" style="display: none;">
            {{one_off_tx=salaryhead.value}}
            </span>
            
            <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Monthely Tax Deduct'" style="display: none;">
            {{monthly_tx=salaryhead.value}}
            </span>
            
            
            <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Total Tax Deduct'" style="display: none;">
            {{total_tx=salaryhead.value}}
            </span>


			
			                <div class="row">
                                <div class="col-md-12" style="font-size: 20px;"><img :src="pgurl+'/public/images/employee/'+fdata.company_id+'/'+fadatamodal.pic+''" width="50" height="50" style="border-radius: 50%; height: auto; margin-right: 10px;">{{fadatamodal.employee_name}}</div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-md-6">
                                    <span class="info-head"><b>Designation:</b> </span>&nbsp;&nbsp;&nbsp;&nbsp;{{fadatamodal.position}}<br />
                                    <span class="info-head">Employee ID: </span>&nbsp;&nbsp;&nbsp;&nbsp;{{fadatamodal.employee_id}}
                                </div>
                                <div class="col-md-6">
                                    <span class="info-head">Fiscal Year: </span>&nbsp;&nbsp;&nbsp;&nbsp;{{fiscal_year}}<br />
                                    <span class="info-head">Month: </span>&nbsp;&nbsp;&nbsp;&nbsp;{{month}}
                                </div>
                            </div>							
							<div class="row no-gutters">
                                <div class="col-md-12 border rounded mt-4">
                                    <h4 class="payslip-modal-headers px-3 py-2 mb-0 border-bottom rounded-top text-left" style="font-size: 16px;">TDS calculation at a glance</h4>
        							<table cellpadding="10" style=" width:100%">
            							<tr class="table-head"><td class="px-3">Gross Salary</td> <td class="px-3">Variable Pay</td> <td class="px-3">Total Deductions</td> <td class="px-3">Income Tax</td> <td class="px-3">Net Pay</td></tr>
            							<tr class="table-row">            							
                							<td class="px-3">
                                                <div v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'salary_without_additions'">
                							              &#2547; {{salaryhead.value.replace("-", "")}} 
                                                </div>
                                            </td> 
                							
                							<td class="px-3"><div v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'total_additions'">
                							              &#2547; {{salaryhead.value.replace("-", "")}} 
                							     </div></td> 
                							
                							
                							
                							<td class="px-3"><div v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '500'">
                							              &#2547; {{salaryhead.value.replace("-", "")}} 
                							     </div></td> 
                							
                							
                							
                							<td class="px-3"><div v-for="salaryhead in taxinfo" :key="salaryhead.head" v-if="salaryhead.displayset == 'ait_adjusted_total_tax'">
                							              &#2547; {{salaryhead.value}} 
                							     </div></td> 
                							
                							
                							<td class="px-3"><div v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '7'">
                							             &#2547; {{salaryhead.value}} 
                							     </div>
                							</td>
            							</tr>
        							</table>
    							</div>
                            
							</div>
							
                            <h4 class="payslip-modal-headers px-3 py-2 mb-0 border rounded-top mt-4 text-left border-bottom-0" style="font-size: 16px;">Payslip Summary</h4>
                            <table style="width: 100%;">
                                <tr class="table-head">
                                    <td class="pl-3 py-2" style="width: 55%;">Details</td>
                                    <td class="py-2" style="width: 5%;"></td>
                                    <td class="py-2 px-2" style="width: 20%;">Amount ( &#2547; )</td>
                                    <td class="pr-3 py-2" align="right" style="width: 20%;">Total ( &#2547; )</td>
                                </tr>
                            </table> 
                            <div class="row accordion-block">
                                <div class="col-md-12">
                                    <div>
                                      <b-button v-b-toggle.collapse-1 variant="primary" class="custom-accordion-btn">
                                        <table style="width: 100%;">
                                            <tr style="">
                                                <td style="width: 90%;">Fixed Salary Components</td>
                                                <td align="right" style="width: 10%;"><i class="fas fa-angle-down rotate-icon"></i></td>
                                            </tr>
                                        </table>
                                      </b-button>
                                      <b-collapse visible id="collapse-1" class="mt-2">
                                        <b-card>
                                        <div v-if="fixed_component_edit_status!=''" class="alert alert-success" >{{fixed_component_edit_status}}</div>
                                        <!--<table style="width: 100%;" v-if="show_edit_div==1">-->
                                        <table style="width: 100%;">
                                                     
                                                      <tr style="border-bottom: dotted 1px #ccc;">
                    							              <td>Arrear Gross Salary</td> <td>&#2547;</td> <td><input id="edit_gross" type="text" class="form-control" v-model="edit_gross" name="edit_gross" v-on:keyup="getOptimized()"></td>
                                                     </tr>
                                                     
                                                     <tr style="border-bottom: dotted 1px #ccc;">
                    							              <td>Arrear Basic Salary</td> <td>&#2547;</td> <td><input id="edit_basic" type="text" class="form-control" v-model="edit_basic" name="edit_basic" v-on:keyup="calculateGross()"></td> 
                                                     </tr>
                                                     
                                                     <tr style="border-bottom: dotted 1px #ccc;">
                    							              <td>Arrear House Rent Allowance</td> <td>&#2547;</td> <td><input id="edit_hra" type="text" class="form-control" v-model="edit_hra" name="edit_hra" v-on:keyup="calculateGross()"></td> 
                                                     </tr>

                                                     <tr style="border-bottom: dotted 1px #ccc;">
                    							              <td>Arrear Conveyance Allowance</td> <td>&#2547;</td> <td><input id="edit_conv" type="text" class="form-control" v-model="edit_conv" name="edit_conv" v-on:keyup="calculateGross()"></td> 
                                                     </tr>


                                                     <tr style="border-bottom: dotted 1px #ccc;">
                    							              <td>Arrear Medical Allowance</td> <td>&#2547;</td> <td><input id="edit_medical" type="text" class="form-control" v-model="edit_medical" name="edit_medical" v-on:keyup="calculateGross()"></td> 
                                                     </tr>
                                                     
                                                     
                                                     <tr>
                                                      <td></td> <td></td> <td>&nbsp;&nbsp; <a v-if="fdata.status != '1'" href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="update_fixed_salary()">Update</a></td> 
                                                     </tr>

                                                     
                                           </table>
                                        
                                        
                                        
                                        
                                             <table style="width: 100%;"  v-if="show_edit_div==0">
                                             
                                             <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.0'  && salaryhead.value!='0.00'  && salaryhead.value!='0'"> 
                                             <template v-if="salaryhead.field_key == 'basic_salary_before_pregross'">
                                                <td style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">{{salaryhead.head}}</td>
                                                <td style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                                <td class="px-2" style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">&#2547; {{salaryhead.value}} <span class="d-block" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.0'  && salaryhead.value!='0.00'  && salaryhead.value!='0' && salaryhead.field_key == 'basic_salary'">[&#2547; {{salaryhead.value}}]</span></td>
                                                <td style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                             </template>
                                             <template v-else-if="salaryhead.field_key == 'house_rent_before_pregross'">
                                                <td style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">{{salaryhead.head}}</td>
                                                <td style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                                <td class="px-2" style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">&#2547; {{salaryhead.value}} <span class="d-block" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.0'  && salaryhead.value!='0.00'  && salaryhead.value!='0' && salaryhead.field_key == 'house_rent'">[&#2547; {{salaryhead.value}}]</span></td>
                                                <td style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                             </template>
                                             <template v-else-if="salaryhead.field_key == 'conveyance_allowance_before_pregross'">
                                                <td style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">{{salaryhead.head}}</td>
                                                <td style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                                <td class="px-2" style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">&#2547; {{salaryhead.value}} <span class="d-block" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.0'  && salaryhead.value!='0.00'  && salaryhead.value!='0' && salaryhead.field_key == 'conveyance_allowance'">[&#2547; {{salaryhead.value}}]</span></td>
                                                <td style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                             </template>
                                             <template v-else-if="salaryhead.field_key == 'medical_allowance_before_pregross'">
                                                <td style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">{{salaryhead.head}}</td>
                                                <td style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                                <td class="px-2" style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">&#2547; {{salaryhead.value}} <span class="d-block" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.0'  && salaryhead.value!='0.00'  && salaryhead.value!='0' && salaryhead.field_key == 'medical_allowance'">[&#2547; {{salaryhead.value}}]</span></td>
                                                <td style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                             </template>
                                             <template v-else>
                                                <template v-if="pre_gross_flag == 1">
                                                    <td class="d-none" style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">{{salaryhead.head}}</td>
                                                    <td class="d-none" style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                                    <td class="d-none" style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">&#2547; {{salaryhead.value}}</td>
                                                    <td class="d-none" style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                                </template>
                                                <template v-else>
                                                    <td style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">{{salaryhead.head}}</td>
                                                    <td style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                                    <td class="px-2" style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">&#2547; {{salaryhead.value}}</td>
                                                    <td style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                                </template>
                                             </template>
                                             </tr>
                                             

                                             
                                             <tr style="" v-for="salaryhead in salaryheads" :key="salaryhead.head"  v-if="salaryhead.displayset == 'total_fixed_salary_component' && show_edit_div==0">
                                                 <template v-if="pre_gross_flag == 1">
                                                     <template v-if="salaryhead.field_key == 'gross_before_pre_gross_deduction'">
                                                         <td style="padding: 10px 5px; width: 55%;"></td>
                                                         <td style="width: 5%; padding: 10px 5px;"></td>
                                                         <td class="px-2" style="padding: 10px 5px; width: 20%;"></td>
                                                         <td align="right" style="width: 20%; padding: 10px 5px;">&#2547; {{salaryhead.value}}<span class="d-block" v-for="salaryhead in salaryheads" :key="salaryhead.head"  v-if="salaryhead.displayset == 'total_fixed_salary_component' && salaryhead.head == 'Total Fixed Salary Component'">[&#2547; {{salaryhead.value}}]</span></td>
                                                     </template>
                                                 </template>
                                                 <template v-else>
                                                     <td style="padding: 10px 5px; width: 55%;"></td>
                                                     <td style="width: 5%; padding: 10px 5px;"></td>
                                                     <td class="px-2" style="padding: 10px 5px; width: 20%;"></td>
                                                     <td align="right" style="width: 20%; padding: 10px 5px;">&#2547; {{salaryhead.value}}</td>
                                                 </template>
                                             </tr>
                                             
                                             
                                             <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.1'  && salaryhead.value!='0.00'  && salaryhead.value!='0'"> 
                                             <td style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">{{salaryhead.head}} (Taxable)</td>
                                             <td style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                             <td class="px-2" style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">&#2547; {{salaryhead.value}}</td>
                                             <td style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                             </tr>
                                             
                                             
                                             <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '2'  && salaryhead.value!='0.00'  && salaryhead.value!='0'">
                                                <td style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">{{salaryhead.head}} (Non Taxable)</td>
                                                <td style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                                <td class="px-2" style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">&#2547; {{salaryhead.value}}</td> 
                                                <td style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);"></td>
                                             </tr>
                                             
                                             </table>
                   
                                             </b-card>
                                      </b-collapse>
                                    </div>
                                 </div>
                             </div>
                             
                             <div class="row accordion-block">
                                <div class="col-md-12">
                                    <b-button v-b-toggle.collapse-2 variant="primary" class="custom-accordion-btn">
                                        <table style="width: 100%;">
                                            <tr style="">
                                                <td style="width: 90%;">Variable Salary Components</td>
                                                <td align="right" style="width: 10%;"><i class="fas fa-angle-down rotate-icon"></i></td>
                                            </tr>
                                        </table>
                                    </b-button>
                                    <b-collapse visible id="collapse-2" class="mt-2">
                                        <b-card>
                                         
                                         <table style="width: 100%;">                
                                         <tr> 
                                         <td style="padding: 10px 0; width: 55%;">Adhoc allowance (Taxable)</td>
                                         <td style="width: 5%;"></td>
                                         <td class="px-2" style="width: 20%;"></td>
                                         <td style="width: 20%;"></td> 
                                         </tr>
                                         
                                         
                             <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'MRI Availed'">
                             <td style="padding: 10px 0; width: 55%;">
                             <div class="row">
                                <div class="col-md-12">
                                
                                 <table style="width: 100%;">
                                 <tr style=""> <td style="width: 55%;"></td> <td style="width: 25%;"></td> <td style="width: 15%;"></td> </tr>                                 
                                 <tr> 
                                 <td colspan="2">
                                 <div class="row">
                                 <div class="col-md-6">
                                    Medical Reimbursement : 
                                 </div>
                                    
                                    <div class="col-md-3"  v-if="fdata.status != '1'">
                                    <input v-if="medical_reimbursement_show_control!='0'" id="medical_reimbursement_value" type="text" class="form-control" v-model="medical_reimbursement_value" name="medical_reimbursement_value" value="0.00">
                                    </div>
                                   
                                    </div>                                   
                                    
                                 </td> 
                                  
                                  <td></td> 
                                 </tr>
                                 
                                 </table>

                                 </div>
                             </div>
                               
                               </td>
                               <td style="width: 5%;"><button href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="removemri()"  v-if="fdata.status != '1' && medical_reimbursement_show_control=='0'" style="width: 40px;">-</button><button id="mri_add" v-if="medical_reimbursement_show_control!='0'" class="btn btn-primary btn-width btn-full-width" @click="savemri()" > + </button></td>
                               <td class="px-2" style="width: 20%;"><span v-if="medical_reimbursement_show_control=='0'">&#2547; {{medical_reimbursement_value_display}}</span></td>
                               <td style="width: 20%;"></td>
                               </tr> 
                             
                                 <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"  v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'adhoc' && salaryhead.value!='0.00' && salaryhead.value!='0'">
    						              <td class="py-1" style="padding: 10px 0; width: 55%;">{{salaryhead.head}}</td>
                                          <td class="py-1" style="width: 5%;"><a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="removeItem(salaryhead.id)"  v-if="fdata.status != '1'">-</a></td> 
                                          <td class="py-1 px-2" style="width: 20%;">&#2547; {{salaryhead.value}}</td> 
                                          <td class="py-1" style="width: 20%;"></td>
                                 </tr>
                             
                                         

                                         
                                         <tr v-if="fdata.status != '1'"> 
                                         <td style="width: 55%;" class="py-3">
                                         <div class="row no-margin">
                                            <div class="col-md-7">
                                            <select id="adhoc_field" v-model="adhoc_field" name="adhoc_field" class="form-control ">
                                            <option value="">Select Salary Head</option>
                                            <option v-for='ahf in adhocfields'  :value='ahf.title'>{{ ahf.title }}</option>
                                            </select>
                                            </div>
                                            
                                            <div class="col-md-3">
                                            <input id="adhoc_field_value" type="text" placeholder="" class="form-control" v-model="adhoc_field_value" name="adhoc_field_value"> 
                                            </div>
                                            
                                            <div class="col-md-2">
                                            
                                            </div>
                                         </div>                                   
                                            
                                         </td> 
                                          
                                          <td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="saveAdhoc()" >+</button></td> 
                                          <td class="px-2" style="width: 20%;"></td> 
                                          <td style="width: 20%;"></td>
                                         </tr>  
                                         
                                         
                                          
                                         <!--  Non taxable Adhoc starts-->
                                         
                                         <tr>
                                         <td style="padding: 10px 0; width: 55%;">Adhoc allowance (Non Taxable)</td>
                                         <td style="width: 5%;"></td>
                                         <td class="px-2" style="width: 20%;"></td>
                                         <td style="width: 20%;"></td>
                                         </tr>
                                         
                                         <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"  v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'adhoc_nontax'">
                                                  <td class="py-1" style="padding: 10px 0; width: 55%;">{{salaryhead.head}}</td>
                                                  <td class="py-1" style="width: 5%;"><a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="removeItem(salaryhead.id)"  v-if="fdata.status != '1'">-</a></td> 
                                                  <td class="py-1 px-2" style="width: 20%;">&#2547; {{salaryhead.value}}</td> 
                                                  <td class="py-1" style="width: 20%;"></td>
                                         </tr>
                                         
                                         <tr v-if="fdata.status != '1'"> 
                                         <td style="width: 55%;" class="py-3">
                                         <div class="row no-margin">
                                         <div class="col-md-7">
                                                <select id="adhoc_nontaxable_field" v-model="adhoc_nontaxable_field" name="adhoc_nontaxable_field" class="form-control ">
                                                <option value="">Non-Taxable Head</option>
                                                <option v-for='anthf in adhocnontaxablefields'  :value='anthf.title'>{{ anthf.title }}</option>
                                                </select>
                                            </div>
                                            
                                            <div class="col-md-3">
                                            <input id="adhoc_nontaxable_field_value" type="text" class="form-control" v-model="adhoc_nontaxable_field_value" name="adhoc_nontaxable_field_value">
                                            </div>
                                            
                                            <div class="col-md-2">
                                            
                                            </div>
                                            </div>                                   
                                            
                                         </td> 
                                          
                                          <td style="width: 5%;" class="py-3"><button class="btn btn-primary btn-full-width" @click="saveAdhocnontaxable()" >+</button></td> 
                                          <td class="px-2" style="width: 20%;"></td> 
                                          <td style="width: 20%;"></td> 
                                         </tr>
                                         <!--<tr style="" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'total_taxable_adhoc'">
        							            <td style="padding: 10px 5px; width: 55%;"></td>
        							            <td style="padding: 10px 5px; width: 5%;"></td>
        							            <td style="padding: 10px 5px; width: 20%;"></td>
                                                <td align="right" style="padding: 10px 5px; width: 20%;">&#2547; {{salaryhead.value}}</td>
                                         </tr>-->
                                            
                                            <tr style="background: #ccf4fe;" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Gross Pay' && show_edit_div==0"> 
                                                 <td class="gross-salary p-2" style="width: 55%;">{{salaryhead.head}}</td>
                                                 <td style="width: 5%;"></td>
                                                 <td class="px-2" style="width: 20%;"></td>
                                                 <td class="p-2" align="right" style="width: 20%;">&#2547; {{salaryhead.value}}</td> 
                                             </tr>
                                             
                                             
                                             <tr v-if="show_edit_div==1"> 
                                             <td class="gross-salary" style="width: 55%;"><!--<b-button v-b-toggle.collapse-GS variant="primary" class="custom-accordion-btn">Arrear Gross </b-button>--></td>
                                             <td style="width: 5%;"></td>
                                             <td class="px-2" style="width: 20%;"></td>
                                             <td style="width: 20%;"></td> 
                                             </tr>                                     
                                         </table>
               
                                         </b-card>
                                     </b-collapse>
                                 </div>
                             </div>
                             
                             
                             
                             <!--fixed deduction starts-->
                             <div class="row accordion-block">
                                <div class="col-md-12">
                                    <b-button v-b-toggle.collapse-3 variant="primary" class="custom-accordion-btn">
                                        <table style="width: 100%;">
                                            <tr style="">
                                                <td style="width: 90%;">Fixed Deduction Components</td>
                                                <td align="right" style="width: 10%;"><i class="fas fa-angle-down rotate-icon"></i></td>
                                            </tr>
                                        </table>
                                    </b-button>
                                    <!-- Card body -->
                                    <b-collapse visible id="collapse-3" class="mt-2">
                                         <b-card>
                                         
                                         <table style="width: 100%;">
                                            <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '5' && salaryhead.value!='0' && salaryhead.value!='-0'">
	                                           <td style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); width: 55%; padding: 10px 0;">{{salaryhead.head}}</td>
                                               <td style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3)"></td>
                                               <td class="px-2" style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); width: 20%; padding: 10px 0;">&#2547; {{salaryhead.value}}</td>
                                               <td style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3)"></td>
                                            </tr>
                                         </table>
               
                                         </b-card>
                                    </b-collapse>
                                 </div>
                             </div>
                             
                             
                             
                             
                             
                             
                             <!--variable deduction starts-->
                             <div class="row accordion-block">
                                <div class="col-md-12">
                                    <b-button v-b-toggle.collapse-4 variant="primary" class="custom-accordion-btn">
                                        <table style="width: 100%;">
                                            <tr style="">
                                                <td style="width: 90%;">Variable Deduction Components</td>
                                                <td align="right" style="width: 10%;"><i class="fas fa-angle-down rotate-icon"></i></td>
                                            </tr>
                                        </table>
                                    </b-button>
                                    <!-- Card body -->
                                    <b-collapse visible id="collapse-4" class="mt-2">
                                         <b-card class="rounded-bottom">
                                         
                                         <table style="width: 100%;">
        
                                         <tr> 
                                         <td>Pre Gross Deduction</td> <td></td> <td></td> 
                                         </tr>
                                         
                                         <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"  v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'pre_adhoc_deduction'"> 
                                                  
                                                  <td class="py-1" style="padding: 10px 0; width: 55%;">{{salaryhead.head}}</td>
                                                  <td class="py-1" style="width: 5%;"><a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="removeItem(salaryhead.id)"  v-if="fdata.status != '1'">-</a></td> 
                                                  <td class="py-1 px-2" style="width: 20%;">&#2547; {{salaryhead.value}}</td> 
                                                  <td class="py-1" style="width: 20%;"></td>
                                         </tr>
                                         
                                         <tr v-if="fdata.status != '1'">                                          
                                          <td style="width: 55%;" class="py-3">
                                          <div class="row no-margin">
                                         <div class="col-md-7">
                                            <select id="adhoc_pre_deduction_field" v-model="adhoc_pre_deduction_field" name="adhoc_pre_deduction_field" class="form-control ">
                                            <option value="">Select Deduction Head</option>
                                            <option v-for='adhf in adhocpredeductionfields'  :value='adhf.title'>{{ adhf.title }}</option>
                                            </select>
                                            </div>
                                            
                                            <div class="col-md-3">
                                            <input id="adhoc_pre_deduction_field_value" type="text" class="form-control" v-model="adhoc_pre_deduction_field_value" name="adhoc_pre_deduction_field_value">
                                            </div>
                                            
                                            <div class="col-md-2">
                                            
                                            </div>
                                            </div>                                   
                                            
                                         </td> 
                                          
                                          <td style="width: 5%;" class="py-3"><button class="btn btn-primary btn-full-width" @click="savePreAdhocdeduction()" >+</button></td> 
                                          <td class="px-2" style="width: 20%;"></td> 
                                          <td style="width: 20%;"></td> 
                                         </tr> 
                                         
                                         <tr> 
                                         <td>Post Gross Deduction</td> <td></td> <td></td> 
                                         </tr>
                                         
                                         <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"  v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'adhoc_deduction'">
                                                  
                                                  <td class="py-1" style="padding: 10px 0; width: 55%;">{{salaryhead.head}}</td>
                                                  <td class="py-1" style="width: 5%;"><a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="removeItem(salaryhead.id)"  v-if="fdata.status != '1'">-</a></td> 
                                                  <td class="py-1 px-2" style="width: 20%;">&#2547; {{salaryhead.value}}</td> 
                                                  <td class="py-1" style="width: 20%;"></td>
                                         </tr>
                                         
                                         <tr v-if="fdata.status != '1'">                                           
                                          <td style="width: 55%;" class="py-3">
                                          <div class="row no-margin">
                                          <div class="col-md-7"  >
                                            <select id="adhoc_deduction_field" v-model="adhoc_deduction_field" name="adhoc_deduction_field" class="form-control ">
                                            <option value="">Select Deduction Head</option>
                                            <option v-for='adhf in adhocdeductionfields'  :value='adhf.title'>{{ adhf.title }}</option>
                                            </select>
                                            </div>
                                            
                                            <div class="col-md-3">
                                            <input id="adhoc_deduction_field_value" type="text" class="form-control" v-model="adhoc_deduction_field_value" name="adhoc_deduction_field_value">
                                            </div>
                                            
                                            <div class="col-md-2">
                                            </div>
                                          </div>                                   
                                            
                                         </td> 
                                          
                                          <td style="width: 5%;" class="py-3"><button class="btn btn-primary btn-full-width" @click="saveAdhocdeduction()" >+</button></td> 
                                          <td class="px-2" style="width: 20%;"></td> 
                                          <td style="width: 20%;"></td> 
                                         </tr>
                                         </table>
               
                                         </b-card>
                                    </b-collapse>
                                 </div>
                             </div>
                             
                             
                             
                             <!-- Investment and AIT Adjustment Starts -->
                             <!--
                             <br />
                             <div class="row">
                                <div class="col-md-12">
                                 <b-card>
                                 
                                 <table style="width: 100%;">
                                 <tr style=""> <td style="width: 55%;"></td> <td style="width: 25%;"></td> <td style="width: 15%;"></td> </tr>
                     
                                <tr v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.displayset == 'max_investment_limit'">
							              <td colspan="3">(Assumed Max allowable yearly investment &#2547; {{taxhead.value}} for tax rebet benifit)</td>  
                                </tr>
                                
                                <tr v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.displayset == 'investment_rebet'">
							              <td colspan="3">(Investment Rebet/ Tax Credit &#2547; {{taxhead.value}})</td>  
                                </tr>
                                
                                <tr v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.displayset == 'invested_amount'">
							              <td colspan="3">(Actual Investment till now &#2547; {{taxhead.value}})</td>  
                                </tr>

                                 
                                 <tr> <td colspan="2"> &nbsp; </td> </tr>
                                 
                                 <tr> 
                                 <td colspan="2">
                                 <div class="row">
                                 <div class="col-md-12 p-top">
                                 <span class="col-md-12 p-top" v-if="ait_adjust_value>0">
                                        AIT Adjustment : &#2547; {{ait_adjust_value}} 
                                 </span>
                                 <span class="col-md-9 p-top" v-else>
                                        AIT Adjustment : &#2547; 0 
                                        </span>
                                 
                                 (Cumulative Amount : <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'ait_adjustment'">
							              &#2547; {{salaryhead.annual}} 
                                </span>)
                                
                                
                                    </div>
                                    
                                    <div class="col-md-3" style="display: none;">
                                    <input id="ait_adjust_value" type="text" class="form-control" v-model="ait_adjust_value" name="ait_adjust_value" value="0.00">
                                    </div>
                                    
                                 
                                    </div> 
                                 </td> 
                                  
                                  <td></td> 
                                 </tr>
                                 
                                 </table>
       
                                 </b-card>
                                 </div>
                             </div>
                             

                             <br /> -->
                             
                             
                            <b-card> 
                            <div class="row">
							<div class="col-md-3"><h4 class="summery-header">Summary</h4></div>
                            
                            <div class="col-md-9">
							<table cellpadding="5" style=" width:100%">
							<tr><td>Gross Salary</td> <td>Variable Pay</td> <td>Total Deductions</td> <td>Income Tax</td> <td>Net Pay</td></tr>
							<tr>
							
							<td><div v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'salary_without_additions'">
							              &#2547; {{salaryhead.value.replace("-", "")}} 
							     </div></td> 
							
							<td><div v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'total_additions'">
							              &#2547; {{salaryhead.value.replace("-", "")}} 
							     </div></td> 
							
							
							
							<td><div v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '500'">
							              &#2547; {{salaryhead.value.replace("-", "")}} 
							     </div></td> 
							
							
							
							<td><div v-for="salaryhead in taxinfo" :key="salaryhead.head" v-if="salaryhead.displayset == 'ait_adjusted_total_tax'">
							              &#2547; {{salaryhead.value}}
							     </div></td> 
							
							
							<td><div v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '7'">
							              &#2547; {{salaryhead.value}} 
							     </div>
							</td>
							</tr>
							</table>
							</div>
                            
							</div>
                            </b-card>
                             
                             <br />
                                 <div align="right" style="float: right;" v-if="fdata.status != '1'">
                                   <a href="javascript:void(0);" class="btn btn-primary btn-width"  @click="reviewed(fadatamodal.id)">Reviewed</a>
                                  &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-width" block @click="$bvModal.hide('payslip_modal')">Close</a>
                                  &nbsp;&nbsp; <button class="btn btn-primary btn-width" @click="saveAIT()" >Update</button>
                                  </div>
			</form>

    
    <!-- Modal Content Ends -->
</div>
  </b-modal>
</div>


<!--Challan Modal Starts-->

<div>
  <b-modal id="challan_modal" :title="'Challan'"  size="lg" hide-footer>

  <b-card>
  	<form @submit="challanformSubmit" enctype="multipart/form-data">
  	<div class="form-group row">
      <label for="name" class="col-md-3 col-form-label">Challan Title: </label>
      <div class="col-md-9">
        <input id="challan_title" type="text" class="form-control" v-model="challanfdata.challan_title" name="challan_title">
      </div>
    </div>
    
    
	<div class="form-group row">
        <div class="col-md-4">
          <label>Company Code:</label> <br />
            <input id="company_code" type="text" class="form-control" v-model="company_code" name="company_code" disabled>
        </div>
        
        <div class="col-md-4">
          <label>Month:</label> <br />
        <select id="month" v-model="challanfdata.month" name="Month" required class="form-control" disabled>
			<option value="January">January</option>
			<option value="February">February</option>
			<option value="March">March</option>
			<option value="April">April</option>
			<option value="May">May</option>
			<option value="June">June</option>
			<option value="July">July</option>
			<option value="August">August</option>
			<option value="September">September</option>
			<option value="October">October</option>
			<option value="November">November</option>
			<option value="December">December</option>
		  </select>
        </div>

            <div class="col-md-4">
              <label>Fiscal year:</label> <br />
               <input id="year" type="text" class="form-control" v-model="challanfdata.fiscal_year" required name="year" placeholder="Year" disabled>
            </div>
       </div>
    
    
    
    	<div class="form-group row">
        <div class="col-md-4">
          <label>Cheque No:</label> <br />
            <input id="cheque_no" type="text" class="form-control" v-model="challanfdata.cheque_no" name="cheque_no">
        </div>
        
        <div class="col-md-4">
          <label>Cheque Date:</label> <br />
           <b-form-datepicker id="cheque_date" type="text" class="form-control" v-model="challanfdata.cheque_date" name="cheque_date"></b-form-datepicker>
        </div>



        <div class="col-md-4">
          <label>Bank Name:</label> <br />
           <input id="bank_name" type="text" class="form-control" v-model="challanfdata.bank_name" name="bank_name">
        </div>
       </div>
        
        
        
    	<div class="form-group row">
        <div class="col-md-6">
          <label>Add People <br> in the Challan List</label> <br />
            <input type="hidden" v-model="current_employee_id" >
            <input type="hidden" v-model="current_employee_etin" >
            <input class="form-control" type="text" v-model="challansearch.name" placeholder="Search People.."@input="challansetSearch()">
           
        <table class="list1" id="employee_dropdown" style="width: 91%; border: 1px solid #CCC; border-collapse:separate; border-radius:6px; -moz-border-radius:6px; position: absolute; z-index: 9999999; background-color: #FFFFFF; display: none;">
		<tr v-for="user in users" :key="user.employee_id" style="border-bottom: 1px solid #CCC;">
        <td style="min-width:200px" v-if="user.etin == ''"> <a style="cursor:pointer;"  @click="chooseemployee(user.name, user.employee_id, user.etin)">{{user.name}}</a></td>
		  <td style="min-width:200px" v-if="user.etin != ''"> <a style="cursor:pointer;"  @click="chooseemployee(user.name, user.employee_id, user.etin)">{{user.name}}-eTIN-{{user.etin}}</a></td>
		</tr>
	  </table>


        </div>
        
        <div class="col-md-2">
          <label>TDS</label> <br /><br />

           <input id="tds_field" type="text" class="form-control" v-model="tds_field" name="tds_field">
        </div>



        <div class="col-md-2">
          <label>TDS (Remaining):</label> <br />

           <input id="tds_remaining" type="text" class="form-control" v-model="tds_remaining" required name="tds_remaining" disabled>

        </div>
        
     <div class="col-md-2">
          <label> &nbsp;</label> <br /><br />

           <a class="btn btn-primary btn-full-width" @click="addemployee()" style="color: #FFFFFF;">+Add</a>

        </div>   
        
        
        </div>
        
      <div v-if="employee_counter != '0'">  
      <table class="table table-bordered table-striped table-hover">
	  <thead>
		<tr>
		  <td>Name</td>
		  <td>eTIN</td>
		  <td>TDS (&#2547;)</td>
		  <td>Actions</td>
		</tr>
        
	  </thead>
	  <tbody>
        
         
        <tr v-for="(value, index) in employeenames" :key="index">
		  <td style="min-width:200px">{{value}} </td>
          <td> {{employeeetins[index]}} </td>
		  <td> {{employeetds[index]}} </td> 
		  <td>&nbsp;&nbsp;&nbsp;&nbsp;<a style="cursor:pointer; color:blue;"  @click="removeemployee(index)">Remove</a></td>
		</tr>


        <tr>
		  <td colspan="2">TDS Total (&#2547;)</td>
          
		  <td colspan="2">{{tds_total}}</td> 
		  
		</tr>
        </tbody>
        </table>
        </div>
        
        <br />
        <div class="form-group row">
        <div class="col-md-6">
        <label>Payee: </label> <br />
        <textarea class="form-control" v-model="challanfdata.payee" rows="5" placeholder=""></textarea>
        </div>
        
        <div class="col-md-6">
        <label>Paying For: </label> <br />
        <textarea class="form-control" v-model="challanfdata.paying_for" rows="5" placeholder=""></textarea>
        </div>
        </div>
        
        
        <br />
        <div class="form-group row">
        <div class="col-md-6">
        <label>Payment Reason: </label> <br />
        <textarea class="form-control" v-model="challanfdata.citation" rows="5" placeholder=""></textarea>
        </div>
        </div>
        

        <div class="form-group row">
        <div class="col-md-10">
        &nbsp;
        </div>
       
        <div class="col-md-2">
         <button class="btn btn-primary btn-full-width" v-if="employeenames.length >0">Submit</button>
         <div v-if="employeenames.length <1" v-b-tooltip.hover title="Add an Employee to Submit"> <a class="btn btn-primary disabled" style="color: #FFFFFF;">Submit</a></div>

        </div>
        </div>
        </form>
  </b-card>
</b-modal>
</div> 

<!-- New payslip Modal Starts-->

 <div>
  <b-modal id="new_payslip_modal" title="Create a New Payslip"  size="lg" hide-footer>  
  <!-- Modal Content Starts -->
  <b-card style="">

  <div class="card-body p-0">
	<div v-if="success_np != ''" class="alert alert-success" role="alert"> {{success_np}} </div>
	<form @submit="newpaysligformSubmit" enctype="multipart/form-data">
	  <div class="form-group row">
		<label for="status"  class="col-md-4 col-form-label">Employee</label>
        <div class="col-md-12">
            <div class="" >                 
                <div class="align-self-center custom-search pr-0 mt-2" style="max-width: 480px;">
                    <b-input-group >
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search by employee / position / code / branch / email / phone" v-model="this_search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
                <table class="list1 bg-white w-100" id="employee_dropdown_payslip" style="border: 1px solid #CCC; border-collapse:separate; border-radius:0.25rem; -moz-border-radius:0.25rem; position: absolute; z-index: 9999999; display: none;">
                    <tr v-for="emply in paginatedData" :key="emply.employee_id" style="border-bottom: 1px solid #CCC; display: block;">
                        <td style="min-width:200px" class="border-bottom px-3 py-2 d-block"> <a style="cursor:pointer;"  @click="choosenewpayslip(emply.name, emply.employee_id)">{{emply.name}}</a></td>
                    </tr>
                </table>
            </div>
        </div>
		<div class="col-md-12 mt-3">
		  <div class="">
              <select id="employee_np" v-model="employee_np" name="employee_np" required class="form-control ">
               <option value="">Select an Employee</option>
    			<option v-for='emply in employees_np'  :value='emply.employee_id'>{{ emply.name }}</option>
    		  </select>
          </div>
		</div>
	  </div>

	  <div class="form-group">
		<div class="">
		  <button class="btn btn-primary btn-full-width">Create Payslip</button>
          <span v-if="new_payslip_loading != ''"><img :src="pgurl+'/public/images/loading.gif'" width="30"></span> 
		</div>
	  </div>
	</form>
  </div>  
  
</b-card>
    
  <!-- Modal Content Ends -->
  </b-modal>
</div> 


<!-- taxcard modals--->
<div v-for="pslip in custom_list" :key="pslip.id" v-if="pslip.id>0">
  <b-modal :id="'taxcard'+pslip.id" title="Taxcard"  size="lg" hide-footer>  
  <!-- Modal Content Starts -->
  <div class="embed-responsive embed-responsive-16by9 z-depth-1">
<iframe class="embed-responsive-item"
          loading="lazy"
          :src="pgurl+'/drafttaxcard/'+pslip.id"
          style="height: 101%"
          allowfullscreen
        />
        </div>
  <!-- Modal Content Ends -->
  </b-modal>
</div>



   
   <!-- this code block commented out by Faroque and added new code bellow
     
   <br />           
   <div v-if="this.payslip_loading==1" style="margin-bottom: 10px;">Loading...</div>
    <div v-else>
	<table class="table" style="margin-top: 20px;">
	  <tbody>
        <tr class="table-head table-head-center">
            <td class="text-left"><input type="checkbox" v-model="selectAll" class=""/></td>
            <td>Name</td>
            <td>Gross Salary</td>
            <td>Variable Pay</td>
            <td>Total Deductions</td>
            <td>Income Tax</td> <td>Net Pay</td>
            <td style="width:285px; text-align: right;"  v-if="fdata.status != '1'">Action</td>
		</tr>
		<tr class="table-row hover-bg" v-for="pslip in payslips" :key="pslip.id" v-if="pslip.id>0">
        <td><input type='checkbox' v-model="payslipids" name='payslipids[]' :value="pslip.id"></td>
		  <td>
          <a  v-if="fdata.status != '1'" @click="displaymodal(pslip.id, pslip.employee_id, pslip.fiscal_year, pslip.from_date, pslip.to_date, pslip.pay_slip_ref, pslip.pay_slip_name, pslip.employee_name, pslip.pic, pslip.position, pslip.ait, pslip.medical_reimbursement)" ><span style="color:#1d68a7; cursor:pointer;">{{pslip.employee}}</span></a>
          <a  v-if="fdata.status == '1'"><span style="color:#3ec197; cursor:pointer;" @click="displaymodal(pslip.id, pslip.employee_id, pslip.fiscal_year, pslip.from_date, pslip.to_date, pslip.pay_slip_ref, pslip.pay_slip_name, pslip.employee_name, pslip.pic, pslip.position, pslip.ait, pslip.medical_reimbursement)">{{pslip.employee}}</span></a>

          </td>
		  <td class="text-right">&#2547; {{pslip.salary_without_additions}}</td>
		  <td class="text-right">&#2547; {{pslip.additions}}</td>
		  <td class="text-right">&#2547; {{pslip.deduction_total}}</td>
		  <td class="text-right">&#2547; {{pslip.taxes_total}}</td>
          <td class="text-right">&#2547; {{pslip.net_salary_total}}</td>
		  <td class="position-relative text-right"  v-if="fdata.status != '1'">
            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
            <div class="dropdown-menu action-dropdown-menu w-200" aria-labelledby="actionDropdown">
                <div><a class="btn btn-primary" style="color: #FFFFFF;" @click="displaymodal(pslip.id, pslip.employee_id, pslip.fiscal_year, pslip.from_date, pslip.to_date, pslip.pay_slip_ref, pslip.pay_slip_name, pslip.employee_name, pslip.pic, pslip.position, pslip.ait, pslip.medical_reimbursement)" ><b-icon icon="pencil-square"></b-icon>Review</a><a class="btn btn-primary" style="color: #FFFFFF;"  @click="displaytaxcardmodal(pslip.id)" ><b-icon icon="eye"></b-icon>Preview Taxcard</a></div>
                <div style="color: green;" v-if="pslip.reviewed=='1'"><i class="fa fa-check-circle" aria-hidden="true"></i>Reviewed</div>
            </div>
		  </td>
		</tr>
	  </tbody>
	  <tfoot>
		<tr>
		  <td colspan="8" class="border-0">
          
                  <div class="row p-2 float-right" v-if="pagination.total > 0">  
                         <ul class="pagination b-pagination" style="margin-bottom: 0;">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled">
                            <b-form-select class="input" type="text" v-model="per_page" @change="setSearch()">
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            </b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{pagination.total}} records found.</li>
                         </ul>              
                        <b-pagination-nav class="float-right" :link-gen="linkGen" v-model="pagination.currentPage" :number-of-pages="pagination_length" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>
            </td>
		</tr>
	  </tfoot>
	</table>
    </div>

    -->
    <div class="payrunpayslip-details">
        <common-list  :pageurl="this.$api_url" :checkbox="checkbox" :is_action="is_action"  :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" :is_payruns="is_payruns" v-on:childToParent="listReturn"></common-list>
    </div>
    
    
    <!-- Payrun User Data Starts Here -->
    <div class="payrun-user-data">
        <div v-for="p_userdata in payrun_userdata" :key="p_userdata.id">
            <div class="row no-margin">
                <div class="col-md-12 p-0 border-top">
                    <span class="p-2 d-inline-block mt-2">Created By</span> - <span class="p-2 d-inline-block mt-2">{{p_userdata.created_user_name}}</span> - <span class="p-2 d-inline-block mt-2">{{formatMe(p_userdata.created_at)}}</span><span class="p-2 d-inline-block mt-2">{{formatTime(p_userdata.created_at)}}</span>
                </div>
                
                <div class="col-md-12 p-0" v-if="p_userdata.status == 1">
                    <span class="p-2 d-inline-block">Approved By</span> - <span class="p-2 d-inline-block">{{p_userdata.approved_user_name}}</span> - <span class="p-2 d-inline-block">{{formatMe(p_userdata.updated_at)}}</span><span class="p-2 d-inline-block">{{formatTime(p_userdata.updated_at)}}</span>
                </div>
            </div>
        </div>
    </div>
    <!-- Payrun User Data Ends Here -->
    
  </div>
  </div>
  </template> 
  <script>
	  import moment from 'moment';
      export default{
		  props: ['pageurl', 'payrun'],
		  mounted() {
			  console.log('started..');            
		  },
		  data(){

        /** Faroque Code Starts Here */
        let sortOrders = {};
        /** Faroque Code Ends Here */

			  return {
			     
                 /** custom field sorting starts **/
                 
                checkbox:1,
                is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                custom_list:[],  /* Data List */
                default_column:['name'], /* Default Column List */
                appended_column:[     
                    { value: "basic_salary", text: "Basic Salary",type: "number"},            
                    { value: "gf_employer_contribution", text: "Employer Contribution",type: "number"},
                    { value: "total_gf_contribution", text: "Total Contribution",type: "number"},
                
                ],                   /* Appended Column List  and there title and type */
                primary_key:'id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                /***Child Component property data */

                tmp_custom_list:[],
                is_payruns: 'yes',
                
                 /** custom field sorting ends **/

          /** Faroque Code Starts Here */
          sortOrders: sortOrders,

          /** Faroque Code Ends Here */


			      payslipids: [],
			      salaryheads : [], 
				  taxinfo : [],
				  fiscalyears: [],
				  adhocfields: [],
				  adhocdeductionfields: [],
                  adhocpredeductionfields:[],
				  adhocnontaxablefields: [],
				  adhocheadsnvalues: [],
				  slabs_and_values : [],
				  fadatamodal: [],   //this.payslip,  
                  modalsuccess: '',
				  employee_id: '',
				  fiscal_year: '',
				  from_date: '',
				  to_date: '',
				  pay_slip_ref: '',
				  pay_slip_name: '',
				  month: '',
				  year: '',
				  adhoc_field: '',
				  adhoc_deduction_field: '',
                  adhoc_pre_deduction_field: '',
				  adhoc_field_value: '',
				  adhoc_deduction_field_value: '',
                  ait_adjust_value:'',  
                  medical_reimbursement_value:'', 
                  payrun_delete_msg:'',
                  pagination_length: 0,
                  link_tracker:0,
                  mri_action:0,
                  medical_reimbursement_value_display:'',
                  medical_reimbursement_show_control:'',
                                 
                  /**one-off management**/
                  one_off_tx:'',
                  monthly_tx:'',
                  total_tx:'',
                  /********************/                  
                  adhoc_pre_deduction_field_value: '',
				  adhoc_nontaxable_field: '',
				  adhoc_nontaxable_field_value: '',
                  payslip_loading:0,
                  approvepass: '',
                  incorrectpass: '',
                  /** off-cycle edit option **/
                  edit_basic: 0,
                  edit_hra: 0,
                  edit_conv: 0,
                  edit_medical: 0,
                  show_edit_div: 0,
                  fixed_component_edit_status: '',
                  edit_gross:'',
                  emailing: '',
                  emailing_success: '',
                  emailsuccess: '',
                  
                  ////////////Challan Modal elements Start/////////
                  
                    users : [], 
                    challanemployees : [], 
                    employeenames : [],
                    employeetds : [],
                    employeeetins : [],
                    challansearch:{name:''},
                    challanfdata: [],  
                    success: '',
                    company_code: '',
                    company_name: '',
                    company_address: '',
                    tds_field: '',
                    tds_remaining:'',
                    tds_total:0,
                    employee_counter:0,
                    current_employee_id:'',
                    current_employee_etin:'',

                  
                  ////////////Challan Modal elements End/////////                                                                                                            
                 
                 
				  payslips : [],  
				  employees : [],
                  payrunsfiscalyear:[],              
				  pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
				  search:{pay_slip_name:'', pay_slip_ref:'', fiscal_year:'', month:'', allparams:''},
				  search_by_id:{employee_id:'',payrun:this.payrun.id, allparams:''},
				  per_page:50,                
				  pgurl:this.$api_url,
				  fdata: this.payrun,
                  payrun_modification_flag:'',
                  loading:'',
				  upload_all : false,
				  emgfile : null,
                  //search_by_id.payrun: this.payrun.id,
                
                
                
                /////////////////////Payslip creation modal
                
                  employees_np : [],
                  success_np : '',
				  prun_id_np:this.payrun_id,
                  employee_np:'',
                  new_payslip_loading: '',
                  showoverlay : false,
                  download_loader : false,
                  download_text : '',
                  
                  payrun_userdata: [],
                  
                  this_search:'',
                  length: 100,
                  this_pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                  
                  column_selected: [],
                  
                  pre_gross_flag: 0,
                  //showdataoverlay: false,
  
			  }
		  },
		  methods:{
		      // added by sohel starts  
              choosenewpayslip(name, id)
              {
                this.employee_np = id;
                document.getElementById('employee_dropdown_payslip').style.display="none";
              },          
              paginate(array, length, pageNumber) 
              {
                    let l = parseInt(array.length);
                    let m = parseInt(length);
                    this.this_pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
                    this.this_pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
                    this.this_pagination.prevPage = pageNumber > 1 ? pageNumber : '';
                    this.this_pagination.nextPage = array.length > this.this_pagination.to ? pageNumber + 1 : '';
        
                    if(l > 0)
                    {
                        this.this_pagination.pages = Math.ceil(l / m);
                    }
                    return array.slice((pageNumber - 1) * length, pageNumber * length);
              },
              resetPagination()
              {
                if(document.getElementById('employee_dropdown_payslip')){
                    if(this.this_search != "")
                        document.getElementById('employee_dropdown_payslip').style.display="block";
                    else
                        document.getElementById('employee_dropdown_payslip').style.display="none";
                }
                    this.this_pagination.currentPage = 1;
                    this.this_pagination.prevPage = '';
                    this.this_pagination.nextPage = '';
              },
              setFirstPage()
              {  
                    this.this_pagination.currentPage = 1;                
                    this.length = this.temp_length;   
              },
		      // added by sohel ends
		      
        formatMe(d)
        {
           return moment(d).format('YYYY/MM/DD');
        },
        
        formatTime (d)
        {
            return moment(d).format('hh:mm:ss A');
        },

        /** Faroque Code Starts Here */
        getPayrunPayslips: function()
        {
          
            if(!this.checkNet()) return false;
            //this.showdataoverlay = true;
            axios.get(this.$api_url+'/list-payslips/' , {
                params: {
                    search_query_by_id: this.search_by_id,
                    flg:1
                }
            }).then(function(response){
                
                //this.this_employees = response.data.employee_data;
                
                //this.payslipids = this.$refs.selected
                
                /* Assingning the Options */ 
                this.company_options = response.data.options;
                
                /* Assingning the list */ 
                this.tmp_custom_list = response.data.employee_data;
                
                if(this.tmp_custom_list.length > 0 )
                {
                    this.tmp_custom_list.forEach(element => {
                            if(element.id > 0)
                            {
                                let dop = []; 
                                if(element.payrun_status != 1 || element.payrun_status == 1)
                                {
                                    this.is_action = 1;
                                    dop = dop.concat([{ label: 'Review' , value: 1 }]);
                                    dop = dop.concat([{ label: 'Preview Taxcard' , value: 2 }]);
                                }

                                element.actions = dop;
                            }
                        });
                    
                }
                this.custom_list = this.tmp_custom_list;
                this.list_key = this.list_key + 1;
              
                    
            }.bind(this)).catch(function (error){this.serverError(error);});
        },

        /** Faroque Code Ends Here */



		      
              displaytaxcardmodal: function(payslip_id)
			  {
			    this.$bvModal.show('taxcard'+payslip_id);
              },
              
 
              

              displaychallanmodal: function(payrun_id)
			  {
			     
                 
                 /////////init for modal/////
                    this.users = [], 
                    this.challanemployees = [], 
                    this.employeenames = [],
                    this.employeetds = [],
                    this.employeeetins = [],
                    this.challanfdata= [],  
                    
                    this.modalsuccess= '',
                    this.company_code= '',
                    this.company_name='',
                    this.company_address= '',
                    this.tds_field= '',
                    this.tds_remaining='',
                    this.tds_total=0,
                    this.employee_counter=0,
                    this.current_employee_id='',
                    this.current_employee_etin='',
                 ///////////////////////////
                 this.getCompanyinfo();
			    this.$bvModal.show('challan_modal');
              },
              
 
 
               displaynewpayslipmodal: function(payrun_id)
			  {
			     this.getEmployeesnewpayslip();
			     this.$bvModal.show('new_payslip_modal');
              },
              
              
              linkGen: function(pageNum)
			  {
			     if(this.link_tracker!=this.pagination.currentPage)
                 {
                    this.link_tracker=this.pagination.currentPage;
                    this.getPayrunPayslips();
                    this.sortBy('employee_name');
                 }
                 
              },
              
              
              
              
              getOptimized: function(pageflg)
			  {
			     
				  this.pagination.currentPage = 1;
						  axios.get(this.$api_url+'/optimizearrear' , {
							  params: {
								  gross_salary: this.edit_gross,
								  medical: 1,
								  hra: 1,
								  conv: 1,
							  }
					  }).then(function(response){
					   
					  this.edit_basic = response.data.data.basic_salary;
                      this.edit_hra = response.data.data.house_rent;
                      this.edit_medical = response.data.data.medical_allowance;
                      this.edit_conv = response.data.data.conveyance_allowance;
                      //console.log(response.data.data.basic_salary);
  
					  
				  }.bind(this));
                  
				 // this.getchallans();
			  }, 
              
              

             calculateGross: function(pageflg)
             {
                
                var basic=",0";
                if(this.edit_basic!="")
                basic=this.edit_basic+",";
                
                var hra=",0";
                if(this.edit_hra!="")
                hra=this.edit_hra+",";


                var medical=",0";
                if(this.edit_medical!="")
                medical=this.edit_medical+",";

                
                var conv=",0";
                if(this.edit_conv!="")
                conv=this.edit_conv+",";

                
                
               this.edit_gross= parseInt(basic.replaceAll(",",""))+parseInt(hra.replaceAll(",",""))+parseInt(medical.replaceAll(",",""))+parseInt(conv.replaceAll(",",""));
             },
		      
              
              displaymodal: function(payslip_id, employee_id, fiscal_year, from_date, to_date, pay_slip_ref, pay_slip_name, employee_name, pic, position, ait, medical_reimbursement)
			  {
			     //alert(payslip_id);
                 
                 /*this.getFiscalyears(); */
                  //alert(pay_slip_ref);
                  this.pre_gross_flag = 0;
                  this.fixed_component_edit_status='';
                  
                  let pay_run_type = parseInt(this.fdata.run_type);
                  
                  if(pay_run_type==11 || pay_run_type ==12)
                  this.show_edit_div=1;
                 
                   this.medical_reimbursement_value=medical_reimbursement;
                   
                   
                   this.medical_reimbursement_value_display=medical_reimbursement;
                   if(parseInt(medical_reimbursement)>0)
                   this.medical_reimbursement_show_control=0;
                   
                   
                   this.ait_adjust_value=ait;
        		   this.fiscal_year=fiscal_year;
        		   this.employee_id=employee_id;
        		   this.from_date=from_date;
        		   this.to_date=to_date;
        		   this.pay_slip_ref=pay_slip_ref;
                   this.fadatamodal.id=payslip_id;
                   this.fadatamodal.employee_name=employee_name;
			       this.fadatamodal.pic=pic;
        		   this.fadatamodal.position=position;
                   this.fadatamodal.employee_id=employee_id;
                   this.success= '',
        		   
        		   this.setSearchmodal();
        		   this.pay_slip_name=pay_slip_name;
        		  
        		  
                 
			    this.$bvModal.show('payslip_modal');
              },
              
              

              getTotalChallan: function(pageflg)
			  {
				  this.pagination.currentPage = 1;
						  axios.get(this.$api_url+'/getpayrunid/'+this.fdata.month+'/'+this.fdata.fiscal_year , {
							  params: {
								  page: this.pagination.currentPage,
								  per_page: this.per_page,
								  search_query: '',
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					   
					  this.fdata.total_challans = response.data.number_of_challan;
  
					  
				  }.bind(this));
                  
				 // this.getchallans();
			  }, 
              
              
              showApproveModal: function(pageflg)
              {
                this.approvepass="";
                this.$bvModal.show('pass-modal'); 
              },
              
              
              showDeleteModal: function(pageflg)
              {
                this.approvepass="";
                this.payrun_delete_msg="Are you sure to delete this gratuity fund run ("+this.fdata.month+", "+this.fdata.year+")?";
                this.$bvModal.show('delete-payrun-modal'); 
              },

              
              
              
              approvePayrun: function(pageflg)
			  {
			    // var pass = prompt(" Are you sure to Approve? \n All the previous gratuity fund runs will be locked after this process is done. \n Please enter your password to continue:", "");
                 
               // alert(pageflg);
                                                                    
                 if(this.approvepass!='')
                 {
                  var pass=this.approvepass;  
			     this.loading='load';
                                                
				  this.pagination.currentPage = 1;
						  axios.get(this.$api_url+'/payrun-update-status/'+pageflg+'/1', {
							  params: {
								  jsonmode: 'on',
                                  pass: pass,								 
							  }
					  }).then(function(response){
					   
					  this.fdata.status = response.data.success;
                      if(this.fdata.status=='1')
                      {
                       this.incorrectpass='';
                       this.$bvModal.hide('pass-modal'); 
                      
                      }
                      else
                      {
                        this.incorrectpass="Incorrect Password";
                      }  
                      this.loading='';                      
  
					  
				  }.bind(this));
                  }                  
                  
				 // this.getchallans();
			  },                  

               destroyMask: function(string){
                return string.replace(/\,/g,'');
               },                
              
		  
               deletePayrun: function(modification_flag)
			  {
			     var msg="Are you Sure?";
                 var routename="";
                 if(modification_flag==1)
                 {
                 msg="Are you sure to reset this Payrun?";
                 routename='resetpayrun';
                 }
                 
                 if(modification_flag==2)
                 {
                 msg="Are you sure to delete this Payrun?";
                 routename='deletepayrun';
                 }
                 
                 if(this.approvepass!='')
                 {
                     var pass=this.approvepass;  
    			     this.loading='load';
    
    					   axios.get(this.$api_url+'/'+routename+'/'+this.fdata.id , {
    						  params: {
    							  page: 1,
                                  jsonmode: 'on',
                                  pass: pass,	
    						  }
    				  }).then(function(response){
    				    

                      if(response.data.success=='1')
                      {
                       this.incorrectpass='';
                       this.$bvModal.hide('pass-modal'); 
                       
                       //if(routename=='deletepayrun')
                       window.location.href = this.$api_url+'/gratuity-fund-runs';
                      
                      }
                      else
                      {
                        this.incorrectpass="Incorrect Password";
                      }  
                      this.loading='';  
                        
                       if(routename=='resetpayrun')
                       this.getPayrunPayslips();	
                       this.sortBy('employee_name');
                       
					   
    			   
    				   
    				  //this.employees = response.data.data;
			          }.bind(this));
                       
                 }
                 
                                                  
              },
              
              modifyPayslipsEmail: function(modification_flag)
              {
                var msg="Are you Sure?";
                this.emailing_success = '';
                if(modification_flag==3){
                    if(this.payslipids.length > 100){
                        alert("You are not allowed to send more than 100 emails in one go!");
                        return false;
                    }else if(this.payslipids.length < 1){
                        alert("Please Select Payslip(s).");
                        return false;
                    }else{
                        msg="Do you want to Email the selected Payslip(s)?";
                        //routename='emailpayslips';
                    }
                    if(confirm(msg)){
                        this.emailing='1';
                        setTimeout(() => {
                            this.emailing='';
                            this.emailing_success='Email sending initiated. Receiver(s) should receive email soon. Please advise receivers to check spam / junk folder too if they complain about the emails are not being received.';
                            this.modifyPayslips(3);
                        }, 5000);
                    }
                }
                if(modification_flag==4){
                    if(this.payslipids.length > 100){
                        alert("You are not allowed to send more than 100 emails in one go!");
                        return false;
                    }else if(this.payslipids.length < 1){
                        alert("Please Select TaxCard(s)");
                        return false;
                    }else{
                        msg="Do you want to Email the selected Taxcard(s)?";
                        //routename='emailpayslips';
                    }
                    
                    if(confirm(msg)){
                        this.emailing='1';
                        setTimeout(() => {
                            this.emailing='';
                            this.emailing_success='Email sending initiated. Receiver(s) should receive email soon. Please advise receivers to check spam / junk folder too if they complain about the emails are not being received.';
                            this.modifyPayslips(4);
                        }, 5000);
                    }
                }
              },
              
              modifyPayslips: function(modification_flag)
			  {
			     
                 var routename="";
                 if(modification_flag==1)
                 {
                    var msg="Are you Sure?";
                 msg="Are you sure to reset the selected Payslips?";
                 routename='resetpayslips';
                 }
                 
                 if(modification_flag==2)
                 {
                    var msg="Are you Sure?";
                 msg="Are you sure to delete the selected Payslips?";
                 routename='deletepayslips';
                 }


                 /*if(modification_flag==3)
                 {
                    if(this.payslipids.length > 100){
                        alert("You are not allowed to send more than 100 emails in one go!");
                        return false;
                    }else if(this.payslipids.length < 1){
                        alert("Please Select Payslip(s).");
                        return false;
                    }else{
                        msg="Do you want to Email the selected Payslip(s)?";
                        routename='emailpayslips';
                    }
                 }*/
               


                 /*if(modification_flag==4)
                 {

                    if(this.payslipids.length > 100){
                        alert("You are not allowed to send more than 100 emails in one go!");
                        return false;
                    }else if(this.payslipids.length < 1){
                        alert("Please Select TaxCard(s)");
                        return false;
                    }else{
                        msg="Do you want to Email the selected Taxcard(s)?";
                        routename='emailpayslips';
                    }
                 }*/

                 //console.log(this.payslipids); 
			  
             if(modification_flag==1 || modification_flag==2)
             {
                 if(confirm(msg))
    			 {
    			     
                         /*if(modification_flag==3 || modification_flag==4)
                         {
                          //this.emailing='1';
                          this.emailsuccess='';
                            
                         }*/
          
        				  let currentObj = this;
          
        				  const config = {
        					  headers: { 'content-type': 'multipart/form-data' }
        				  }
          
          
        				  let formData = new FormData();
                          formData.append('payslipids', this.payslipids);
                          formData.append('modification_flag', modification_flag);
          
        				  axios.post(this.$api_url+'/modifypayslips', formData, config)
          
        				  .then(function (response) {
    
                            currentObj.getPayrunPayslips();
                            currentObj.sortBy('employee_name');
                            //currentObj.emailing='';
                            currentObj.emailsuccess=response.data.success;
                            //console.log('Payslip IDs: '+currentObj.payslipids.length);
                            currentObj.payslipids = [];
    
          
        				  })
          
        				  .catch(function (error) {
          
        					  currentObj.output = error;
          
        				  });
                          
    
                           
                  }
              }else{
                    let currentObj = this;
          
    				  const config = {
    					  headers: { 'content-type': 'multipart/form-data' }
    				  }
      
      
    				  let formData = new FormData();
                      formData.append('payslipids', this.payslipids);
                      formData.append('modification_flag', modification_flag);
      
    				  axios.post(this.$api_url+'/modifypayslips', formData, config)
      
    				  .then(function (response) {

                        currentObj.getPayrunPayslips();
                        currentObj.sortBy('employee_name');
                        //currentObj.emailing='';
                        currentObj.emailsuccess=response.data.success;
                        //console.log('Payslip IDs: '+currentObj.payslipids.length);
                        currentObj.payslipids = [];

      
    				  })
      
    				  .catch(function (error) {
      
    					  currentObj.output = error;
      
    				  });
              }
                 
                                                  
              },

              
 
             downloadTaxcards: function()
			  {
                 
                 if(this.payslipids.length>0){
                 
                 var msg="Are you sure to download the selected Taxcards?";
                 if(confirm(msg))
    			 {
          
        				  let currentObj = this;
          
        				  const config = {
        					  headers: { 'content-type': 'multipart/form-data' }
        				  }
          
        				  let formData = new FormData();
                          formData.append('payslipids', this.payslipids);
                          //formData.append('modification_flag', modification_flag);
                          currentObj.download_loader = true;
                          currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';
          
        				  axios.post(this.$api_url+'/downloadtaxcards', formData, config)
          
        				  .then(function (response) {
        				    
                            var fname = response.data.file_name;
                            if(response.data.download_file_name)
                            var download_f_name =   response.data.download_file_name;
                            else
                            var download_f_name =   fname; 
                            if(download_f_name.length>0)
                            window.location.href = currentObj.$api_url+'/downloadziptaxcard?file_name='+fname+'&download_file_name='+download_f_name;     
                            else
                            currentObj.$bvToast.toast('Unable to download. Server error', {title: 'Error!',variant: 'danger',solid: true});
                            
                            currentObj.download_loader = false;
                            currentObj.download_text = '';
        				  })
          
        				  .catch(function (error) {
          
        					  currentObj.output = error;
                              currentObj.download_loader = false;
                              currentObj.download_text = '';
          
        				  });
      
                  }
                 
                 }else{
                    this.$bvToast.toast('Please select Employee', {title: 'Error!',variant: 'danger',solid: true});
                 }                                 
              },




              
 
             downloadAllTaxcards: function()
			  {
                 
                 var msg="Are you sure to download all Taxcards?";
                 if(confirm(msg))
    			 {
          
        				  let currentObj = this;
          
        				  const config = {
        					  headers: { 'content-type': 'multipart/form-data' }
        				  }
          
        				  let formData = new FormData();
                          //formData.append('payslipids', this.payslipids);
                          //formData.append('modification_flag', modification_flag);
                          
                          //formData.append('payslipids', this.payslipids);
                          formData.append('all_payslips', 'yes');
                          
                          //alert(this.payrun.id);
                          formData.append('payrun_id', this.payrun.id);
                          
                          this.$bvToast.toast('We are processing your download. This may take a while.', {title: 'Downloading!',variant: 'success',solid: true});
                          
                          
                          currentObj.download_loader = true;
                          currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';
          
        				  axios.post(this.$api_url+'/downloadtaxcards', formData, config)
          
        				  .then(function (response) {
        				    
                            var fname = response.data.file_name;
                            if(response.data.download_file_name)
                            var download_f_name =   response.data.download_file_name;
                            else
                            var download_f_name =   fname; 
                            
                            if(download_f_name.length>0)  
                            window.location.href = currentObj.$api_url+'/downloadziptaxcard?file_name='+fname+'&download_file_name='+download_f_name;     
                            else
                            currentObj.$bvToast.toast('Unable to download. Server error', {title: 'Error!',variant: 'danger',solid: true});
                            
                            currentObj.download_loader = false;
                            currentObj.download_text = '';
        				  })
          
        				  .catch(function (error) {
          
        					  currentObj.output = error;
                              currentObj.download_loader = false;
                              currentObj.download_text = '';
          
        				  });
      
                  }
                 
                                
              },





             
              downloadPayslips: function()
			  {
                 
                 if(this.payslipids.length>0){
                 var msg="Are you sure to download the selected GF slips?";
                 if(confirm(msg))
    			 {
          
        				  let currentObj = this;
        				  const config = {
        					  headers: { 'content-type': 'multipart/form-data' }
        				  }
        				  let formData = new FormData();
                          formData.append('payslipids', this.payslipids);
                          formData.append('gf_slip', 1);
                          currentObj.download_loader = true;
                          currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';
        				  axios.post(this.$api_url+'/downloadpayslips', formData, config)
        				  .then(function (response) {
                            var fname=response.data.file_name;
                            if(response.data.download_file_name)
                            var download_f_name =   response.data.download_file_name;
                            else
                            var download_f_name =   fname; 
                            if(download_f_name.length>0)    
                            window.location.href = currentObj.$api_url+'/downloadzippayslip?file_name='+fname+'&download_file_name='+download_f_name+'&gf_slip=1'; 
                            else
                            currentObj.$bvToast.toast('Unable to download. Server error', {title: 'Error!',variant: 'danger',solid: true});
                            currentObj.download_loader = false;  
                            currentObj.download_text = ''; 
        				  })
        				  .catch(function (error) {
        					  currentObj.output = error;
                              currentObj.download_loader = false;
                              currentObj.download_text = '';
        				  });         
                  }  
                  }else{
                    this.$bvToast.toast('Please select Employee', {title: 'Error!',variant: 'danger',solid: true});
                 }                                
              },




              downloadAllPayslips: function()
			  {
                 
                 var msg="Are you sure to download all Payslips?";
                 if(confirm(msg))
    			 {
          
        				  let currentObj = this;
        				  const config = {
        					  headers: { 'content-type': 'multipart/form-data' }
        				  }
        				  let formData = new FormData();
                          //formData.append('payslipids', this.payslipids);
                          formData.append('all_payslips', 'yes');
                          
                          //alert(this.payrun.id);
                          formData.append('payrun_id', this.payrun.id);
                          formData.append('gf_slip', 1);                          
                          
                          this.$bvToast.toast('We are processing your download. This may take a while.', {title: 'Downloading!',variant: 'success',solid: true});
                          
                          currentObj.download_loader = true;
                          currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';
        				  axios.post(this.$api_url+'/downloadpayslips', formData, config)
        				  .then(function (response) {
                            var fname=response.data.file_name;
                            if(response.data.download_file_name)
                            var download_f_name =   response.data.download_file_name;
                            else
                            var download_f_name =   fname; 
                            if(download_f_name.length>0)    
                            window.location.href = currentObj.$api_url+'/downloadzippayslip?file_name='+fname+'&download_file_name='+download_f_name+'&gf_slip=1';  
                            else
                            currentObj.$bvToast.toast('Unable to download. Server error', {title: 'Error!',variant: 'danger',solid: true});
                            
                            currentObj.download_loader = false;
                            currentObj.download_text = '';   
        				  })
        				  .catch(function (error) {
        					  currentObj.output = error;
                              currentObj.download_loader = false;
                              currentObj.download_text = '';
        				  });         
                  }  
                                               
              },


 
 
 
               downloadBankfile: function()
			  {
                 
                 window.location.href = this.$api_url+'/payroll_bankfile?payrun_id='+this.fdata.id;  
                                                  
              },


 
 
              
              
              redirect_to_payruns: function()
			  {
                  window.location.href = this.$api_url+'/gratuity-fund-runs?fiscal_year='+this.search.fiscal_year+'&month='+this.search.month;
			  },
              
              saveAIT: function()
			  {
                  this.$bvModal.hide('payslip_modal');
                  this.getPayrunPayslips();
                  this.sortBy('employee_name');
			  },
              
              
              
              savemri: function()
			  {
                  
                  this.getPayrunPayslips();
                  this.sortBy('employee_name');
			  },
              
              
              removemri: function()
			  {
			      this.medical_reimbursement_show_control='';
                  this.medical_reimbursement_value=0;
                  
                  //document.getElementById('mri_add').click();
                  
                  this.getPayrunPayslips();
                  this.sortBy('employee_name');
			  },
              
              
              
              
              getpayrunsfiscalyear: function()
			  {
  
						  axios.get(this.$api_url+'/list-payruns-fiscalyear/0' , {
							  params: {
								  page: this.pagination.currentPage,
								  per_page: 100,
								  search_query: '',
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.payrunsfiscalyear = response.data.data;
  
					  this.pagination.from = response.data.from;
					  this.pagination.to = response.data.to;
					  this.pagination.total = response.data.total;
					  
					  if(this.pagination.to==this.pagination.total)
					  {
						  
						  this.pagination.nextbuttonstatus = 'disabled';
						  
					  }
					  else
					  {
						   this.pagination.nextbuttonstatus = '';
					  }
					  
					  if(this.pagination.from==1)
					  {
					    this.pagination.prebuttonstatus = 'disabled';
					  }
					  else
					  {
						 this.pagination.prebuttonstatus = ''; 
					  }
  
  
  
					  if(this.pagination.currentPage < response.data.last_page)
						  this.pagination.nextPage = this.pagination.currentPage + 1;
  
					  if(this.pagination.currentPage == 1)
						  this.pagination.prevPage = 1;
					  else 
						  this.pagination.prevPage = this.pagination.currentPage - 1;
				  }.bind(this));
			  },
          
		  
			
			  setSearch: function(pageflg)
			  {
				  this.pagination.currentPage = 1;
				  this.getPayrunPayslips();
                  this.sortBy('employee_name');
			  },
  			setPagination: function(pageflg)
			  {                
				  if(pageflg)
					  this.pagination.currentPage = this.pagination.nextPage;
				  else    
					  this.pagination.currentPage = this.pagination.prevPage;
				  
				  this.getPayrunPayslips();
                  this.sortBy('employee_name');
			  },
			  getpayslips: function()
			  {
			     this.payslip_loading=1;
  
						  axios.get(this.$api_url+'/list-payslips' , {
							  params: {
								  page: this.pagination.currentPage,
								  per_page: this.per_page,
								  search_query: this.search,
								  search_query_by_id: this.search_by_id,
							  }
					  }).then(function(response){
					   
					   //console.log(response.data[1]);
                     // alert(response.data.data.allparams);
                     //alert(this.search.allparams);
                       this.payslip_loading=0;
                      if(response.data[1]==this.search.allparams)                     
					  this.payslips = response.data[0].data;                //response.data.data;
  
					  this.pagination.from = response.data[0].from;
					  this.pagination.to = response.data[0].to;
					  this.pagination.total = response.data[0].total;
                      
                      
                      if(this.pagination.total>0)
                      {
                        this.pagination_length=Math.ceil((this.pagination.total/this.per_page));
                      }
                      
					  
					  if(this.pagination.to==this.pagination.total)
					  {
						  
						  this.pagination.nextbuttonstatus = 'disabled';
						  
					  }
					  else
					  {
						   this.pagination.nextbuttonstatus = '';
					  }
					  
					  if(this.pagination.from==1)
					  {
					    this.pagination.prebuttonstatus = 'disabled';
					  }
					  else
					  {
						 this.pagination.prebuttonstatus = ''; 
					  }
  
  
  
					  if(this.pagination.currentPage < response.data.last_page)
						  this.pagination.nextPage = this.pagination.currentPage + 1;
  
					  if(this.pagination.currentPage == 1)
						  this.pagination.prevPage = 1;
					  else 
						  this.pagination.prevPage = this.pagination.currentPage - 1;
				  }.bind(this));
			  },
              
              
              /******* Payslip Modal Methods starts**************/
              
			  createTag: function()
			  {
			      //alert(this.from_date);
				  var fromdate=this.from_date;
				  var fromdatearray=fromdate.split("-");
				  var mnth=fromdatearray[1];
				  var month="";
				  var day="";
				  var year=fromdatearray[0];
				  if(mnth=="01")
				   month="January";

				  if(mnth=="02")
				   month="February";

				  if(mnth=="03")
				   month="March";

				  if(mnth=="04")
				   month="April";

				  if(mnth=="05")
				   month="May";

				  if(mnth=="06")
				   month="June";

				  if(mnth=="07")
				   month="July";

				  if(mnth=="08")
				   month="August";

				  if(mnth=="09")
				   month="September";

				  if(mnth=="10")
				   month="October";

				  if(mnth=="11")
				   month="November";
				   
				   if(mnth=="12")
				   month="December";
				   
				   if(mnth=="09" || mnth=="04" || mnth=="06" || mnth=="11")
				   day="30";
				   else
				   day="31";

                   this.to_date=day+" "+month+", "+year;
				   
				 var employee_name="Employee";  
				 var employeearray= this.employees;			   
					this.employees.forEach((value, index) => {
					if(this.employee_id==value.employee_id)
					employee_name=value.name;
					//console.log(value.name);
					//console.log(index);
					});
					
					//this.pay_slip_name="Salary Slip of "+employee_name+" for "+month+", "+year;
					//this.pay_slip_ref=this.employee_id+"-"+month+"-"+year;
					this.month=month;
					this.year=year;

				  
				  
			  },
			  
			  setSearchmodal: function(pageflg)
			  {
			    if(this.from_date!='')
			    this.createTag();
				this.getSalaryinfo(); 
			  },
			  
			  showAdhoc: function(pageflg)
			  {
			    document.getElementById("adhoc_div").style.display="block";
				document.getElementById("adhoc_link_div").style.display="none";
				document.getElementById("status_div").style.display="none";
				
			  },
			  
			  hideAdhoc: function(pageflg)
			  {
			    document.getElementById("adhoc_div").style.display="none";
				document.getElementById("adhoc_link_div").style.display="block";
				document.getElementById("status_div").style.display="block";
				
			  },
			  
			  removeItem: function(pageflg)
			  {
			    //alert(pageflg);
				if(confirm("Are you Sure to Delete?"))
				{
					axios.get(this.$api_url+'/delete-adhoc/'+pageflg , {
								  params: {
									  page: 1,
									  
								  }
						  }).then(function(response){
							this.getSalaryinfo();   
	  
					  }.bind(this));
				  }
				
			  },

              reviewed:function(pageflg)
			  {

					axios.get(this.$api_url+'/review-status/'+pageflg , {
								  params: {
									  page: 1,
									  
								  }
						  }).then(function(response){
							//this.getSalaryinfo();   
                            this.$bvModal.hide('payslip_modal'); 
                            this.getPayrunPayslips();  
                            this.sortBy('employee_name');                         
	  
					  }.bind(this));

				
			  },
			  
			  saveAdhoc: function(pageflg)
			  {
                if(this.adhoc_field=="")
                {			     
			    alert("Please Choose an Adhoc Head") ;
                }
                else
                {
                    if(this.adhoc_field_value=="")
                    alert("Please Enter Adhoc Head Value") ;
                }
                
				
			  },
			  
			  getEmployees: function()
			  {
  
						  axios.get(this.$api_url+'/getemployees' , {
							  params: {
								  page: 1,
								  per_page: 1000000,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.employees = response.data.data;
  
  
				  }.bind(this));
			  },
              
 
 			  update_fixed_salary: function()
			  {
  
						  axios.get(this.$api_url+'/update_fixed_salary' , {
							  params: {
								  basic: this.edit_basic,
								  conv: this.edit_conv,
								  medical: this.edit_medical,
								  hra: this.edit_hra,
                                  payslip_id:this.fadatamodal.id,                                  
							  }
					  }).then(function(response){
					  
                      this.fixed_component_edit_status= response.data.success;
                      this.getSalaryinfo(); 
  
  
				  }.bind(this));
			  },
             
			  getFiscalyears: function()
			  {
  
						  axios.get(this.$api_url+'/getfiscalyears' , {
							  params: {
								  page: 1,
								  per_page: 10,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.fiscalyears = response.data;
  
  
				  }.bind(this));
			  },

  
			  
			   getSalaryinfo: function()
			  {
						  axios.get(this.$api_url+'/salary-slip/'+this.employee_id , {
							  params: {
								  fiscal_year: this.fiscal_year,
								  payslip_id: this.fadatamodal.id,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  //alert(response.data.salary);
                      //this.getPayrunPayslips();
                      this.getPayrunPayslips();
                      this.sortBy('employee_name');
                      
                      var test = response.data.salary;
                      
					  this.salaryheads = response.data.salary;
                      /* Added by Sohel starts */
                      this.salaryheads.forEach(element => {
                        
                        if(element.field_key == 'basic_salary_before_pregross' || element.field_key == 'house_rent_before_pregross' || element.field_key == 'conveyance_allowance_before_pregross' || element.field_key == 'medical_allowance_before_pregross')
                        {
                            this.pre_gross_flag = 1;
                        }
                        
                      });
                      /* Added by Sohel ends */
					  this.slabs_and_values=response.data.slabsnvalues;
					  this.taxinfo=response.data.tax;
					  this.adhocfields=response.data.adhocfields;
					  this.adhocdeductionfields=response.data.adhocdeductionfields;
                      this.adhocpredeductionfields=response.data.adhocpredeductionfields;
					  this.adhocheadsnvalues=response.data.adhocheadsnvalues;
					  this.adhocnontaxablefields=response.data.adhocnontaxablefields;

 
                      
                      test.forEach((value, index) => {

                        if(value.head=="Basic Salary")
                        this.edit_basic=value.value;
                        
                        if(value.head=="House Rent Allowance")
                        this.edit_hra=value.value;


                        if(value.head=="Conveyance Allowance")
                        this.edit_conv=value.value;


                        if(value.head=="Medical Allowance")
                        this.edit_medical=value.value;
                        
                        
                        
                        let arr_field_val = value.value;
                        //alert(arr_field_val);
                        
                        if(value.head=="Arrear Basic Salary" && arr_field_val.length >0)
                        this.edit_basic = value.value;   
                        
                        if(value.head=="Arrear HRA" && arr_field_val.length >0)
                        this.edit_hra = value.value;
                        
                        if(value.head=="Arrear Conveyance" && arr_field_val.length >0)
                        this.edit_conv = value.value;
                        
                        if(value.head=="Arrear Medical" && arr_field_val.length >0)
                        this.edit_medical = value.value;
                        
                        
                        this.calculateGross();
                                               
                        //console.log(index);
                        });                     
					  
  
  
				  }.bind(this));
			  },
			  

			  
			  setSalaryinfo: function()
			  {
			  //
			  },
			  
			  
			  
  
  
			  formSubmit(e) {
  
				  e.preventDefault();
  
				  let currentObj = this;
  
   
  
				  const config = {
  
					  headers: { 'content-type': 'multipart/form-data' }
  
				  }
  
   
  
				  let formData = new FormData();
  
                   //formData.append('filename', this.image); 
                   
                   //alert(this.pay_slip_ref);
                   
                   
				   formData.append('employee_id', this.employee_id);
				   formData.append('pay_slip_ref', this.pay_slip_ref);
				   formData.append('pay_slip_name', this.pay_slip_name);
				   formData.append('month', this.month);
				   formData.append('year', this.year);
				   formData.append('from_date', this.from_date);
				   formData.append('to_date', this.to_date);
				   formData.append('fiscal_year', this.fiscal_year); 
				   if(this.adhoc_field!='')
				   formData.append('adhoc_field', this.adhoc_field);
				   if(this.adhoc_field_value!='')
				   formData.append('adhoc_field_value', this.adhoc_field_value);
				   
				   if(this.adhoc_deduction_field!='')
				   formData.append('adhoc_deduction_field', this.adhoc_deduction_field);
                   if(this.adhoc_pre_deduction_field!='')
				   formData.append('adhoc_pre_deduction_field', this.adhoc_pre_deduction_field);
                   
				   if(this.adhoc_deduction_field_value!='')
				   formData.append('adhoc_deduction_field_value', this.adhoc_deduction_field_value);
                   


				   //if(this.medical_reimbursement_value!='')
				   formData.append('medical_reimbursement_value', this.medical_reimbursement_value);
                   
                   
				   if(this.ait_adjust_value!='')
				   formData.append('ait_adjust_value', this.ait_adjust_value);
                   
				   if(this.adhoc_pre_deduction_field_value!='')
				   formData.append('adhoc_pre_deduction_field_value', this.adhoc_pre_deduction_field_value);


				   if(this.adhoc_nontaxable_field!='')
				   formData.append('adhoc_nontaxable_field', this.adhoc_nontaxable_field);
				   if(this.adhoc_nontaxable_field_value!='')
				   formData.append('adhoc_nontaxable_field_value', this.adhoc_nontaxable_field_value);

  
				  axios.post(this.$api_url+'/payslip-action-vue', formData, config)
  
				  .then(function (response) {
                      currentObj.getSalaryinfo();
					  currentObj.success = response.data.success;
					  currentObj.fadatamodal.id = response.data.payslip_id;
					  currentObj.adhoc_field_value="";
					  currentObj.adhoc_field="";
                      
					  currentObj.medical_reimbursement_value_display=currentObj.medical_reimbursement_value;
                      
                      if(parseInt(currentObj.medical_reimbursement_value)>0)
                      currentObj.medical_reimbursement_show_control=0;
                      
					  currentObj.adhoc_deduction_field_value="";
					  currentObj.adhoc_deduction_field="";
                      currentObj.adhoc_pre_deduction_field_value="";
					  currentObj.adhoc_pre_deduction_field="";
					  currentObj.adhoc_nontaxable_field_value="";
					  currentObj.adhoc_nontaxable_field="";
                      currentObj.getSalaryinfo();
					  //currentObj.getpayslips();
					  currentObj.hideAdhoc();
					  
  
				  })
  
				  .catch(function (error) {
  
					  currentObj.output = error;
  
				  });
  
			  },
              
              
              /*****************Payslip Modal Method Ends******/
              
              
              ////////////Challan Modal Method Starts////////////
              
 		  chooseemployee: function(name, id, etin)
		  { 
		  var default_tds=0;
          var default_remaining=0;
		  axios.get(this.$api_url+'/gettds/'+id , {
							  params: {
								  page: '',
								  per_page: '',
								  search_query: '',
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  
					  default_tds = response.data.tds;
                      default_remaining=response.data.remains;
  
		  
		  if (this.challanemployees.indexOf(id) === -1) {
					  /*var val=name+"---"+id;
					  this.challanemployees.push(id);
					  this.employeenames.push(name);
					  this.employeetds.push(default_tds);*/
					  
					  this.challansearch.name=name;
                      this.current_employee_id=id;
                      this.current_employee_etin=etin;
                      this.tds_field=default_tds;
                      this.tds_remaining=default_remaining;
					  this.users=[];
					  //this.updatestack();
                      document.getElementById("employee_dropdown").style.display="none";

				 
				}
				else
				{alert("This employee already added.");}
				  
				  }.bind(this));
		  

		  },
          
          
          addemployee: function(index)
			  {
			     var tds_validity="No";
			     var tds=Number(this.tds_field);
                 var remaining=Number(this.tds_remaining);
                 if(tds<=remaining)
                 tds_validity="Yes";
                 else
                 {
                   alert("TDS can not be greater than remaining."); 
                 }
                 
                 
                 
				      if(this.current_employee_id!="" && this.challansearch.name!="" && this.tds_field!="" && tds_validity=="Yes")
                      {
					  this.challanemployees.push(this.current_employee_id);
					  this.employeenames.push(this.challansearch.name);
					  this.employeetds.push(this.tds_field);
                      this.employeeetins.push(this.current_employee_etin);
					  this.updatestack();
                      
                      this.challansearch.name="";
                      this.current_employee_id="";
                      this.tds_field="";
                      this.tds_remaining="";
                      this.current_employee_etin="";
					  this.users=[];
                      }
				  
			  },
          
		  
		  
		   removeemployee: function(index)
			  {
				  
					  this.challanemployees.splice(index, 1);
					  this.employeenames.splice(index, 1);
					  this.employeetds.splice(index, 1);
                      this.employeeetins.splice(index, 1);
					  
					  this.updatestack();
				  
			  },
			  
			  
			  updatestack: function()
			  {
				  
				 //alert(this.challanemployees.length);
				 var arlength=this.challanemployees.length;
				 var counter=0;
				 var stacktxt="";
				 var endofstack=arlength-1;
                 this.tds_total=0;
                 this.employee_counter=0;
				 for(counter=0; counter<arlength; counter++)
				 {
					
					if(counter==endofstack)
					stacktxt=stacktxt+this.challanemployees[counter]+"="+this.employeetds[counter];
					else
					stacktxt=stacktxt+this.challanemployees[counter]+"="+this.employeetds[counter]+"^^";
                    
                    this.tds_total=this.tds_total+Number(this.employeetds[counter]);
                    this.employee_counter=this.employee_counter+1;
				 
				 }
				 
				 this.challanfdata.company_employee=stacktxt;
                 this.challanfdata.total_amount=this.tds_total;
                 this.challanfdata.money_details="Cheque-"+this.challanfdata.cheque_no+" from "+this.challanfdata.bank_name;
                 

			  },
			  
			  challansetSearch: function(pageflg)
			  {
				  
				  this.challangetEmployees();
                 
			  },
  
			  
		      challangetEmployees: function()
			  {
			     if(this.challansearch.name!="")
			     document.getElementById("employee_dropdown").style.display="block";
                 else
                 document.getElementById("employee_dropdown").style.display="none";
  
						  axios.get(this.$api_url+'/allemployees' , {
							  params: {
								  page: 1,
								  per_page: 15,
								  search_query: this.challansearch,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.users = response.data.data;
  
  
				  }.bind(this));
			  },
			  
			  getCompanyinfo: function()
			  {
  
						  axios.get(this.$api_url+'/companyinfo' , {
							  params: {
								  page: 1,
								 
							  }
					  }).then(function(response){
					  this.company_code = response.data.company_code;
					  this.company_name = response.data.company_name;
					  this.company_address = response.data.company_address;
					  
					  this.challanfdata.month = response.data.month;
					  this.challanfdata.fiscal_year = response.data.year;
                      this.challanfdata.challan_title="Challan of "+this.company_name+", "+this.challanfdata.month+" "+this.challanfdata.fiscal_year;
                      this.challanfdata.payee=this.company_name+"\n"+this.company_address;
                      this.challanfdata.paying_for="Employees of \n"+this.company_name+"\n"+this.company_address;
                      this.challanfdata.citation="Tax deducted at source from salary under section 50 of the Income tax Ordinance 1984";
  
  
				  }.bind(this));
			  },

			  
			  setemployee: function()
			  {
			  
				//alert(this.challanfdata.company_employee);
               var eployeelist=this.challanfdata.company_employee;
			   var employeearray= eployeelist.split("^^");
			   
				 var arlength=employeearray.length;
				 var counter=0;
				 var endofstack=arlength-1;
				 for(counter=0; counter<arlength; counter++)
				 {   
					  var empltxt=employeearray[counter];
					  var empltxtarray= empltxt.split("=");
				 
					  this.challanemployees.push(empltxtarray[0]);
					  this.employeenames.push(empltxtarray[2]);
					  this.employeetds.push(empltxtarray[1]);
				 
				 }
				 
				 this.updatestack();
			  
			  
			  },
              
              
              saveAdhocnontaxable: function()
			  {
			  
                if(this.adhoc_nontaxable_field=="")
                {			     
			    alert("Please Choose a Non-Taxable Adhoc Head") ;
                }
                else
                {
                    if(this.adhoc_nontaxable_field_value=="")
                    alert("Please Enter Non-Taxable Adhoc Head Value") ;
                }

			  },
              
              savePreAdhocdeduction: function()
			  {
                if(this.adhoc_pre_deduction_field=="")
                {			     
			    alert("Please Choose a Pre Deduction Head") ;
                }
                else
                {
                    if(this.adhoc_pre_deduction_field_value=="")
                    alert("Please Enter Pre Deduction Head Value") ;
                }
			  
                 
			  },
              
              
              saveAdhocdeduction: function()
			  {
			     
                 if(this.adhoc_deduction_field=="")
                {			     
			    alert("Please Choose a Post Deduction Head") ;
                }
                else
                {
                    if(this.adhoc_deduction_field_value=="")
                    alert("Please Enter Post Deduction Head Value") ;
                }
			  
                 
			  },
              
              
			  
			  
			  
  
  
			  challanformSubmit(e) {
			     
                 var added_employee=this.employeenames.length;
                 
                 if(added_employee<1)
                 {
                   // alert("Please Add an Employee");
                    return 0;
                 }
                 
  
				  e.preventDefault();
  
				  let currentObj = this;
  
				  const config = {
  
					  headers: { 'content-type': 'multipart/form-data' }
  
				  }
  
   
  
				  let formData = new FormData();
  
				  for (let [key, value] of Object.entries(this.challanfdata)) {
					  
						var nm=`${key}`;
					   var fval=`${value}`;
					   formData.append(nm, fval);
					  
					  console.log(`${key}: ${value}`);
				  }
   
  
				  axios.post(this.$api_url+'/challanstorevue', formData, config)
  
				  .then(function (response) {
  
					  currentObj.modalsuccess = response.data.success;
                      currentObj.$bvModal.hide('challan_modal');
                      currentObj.getTotalChallan();
  
				  })
  
				  .catch(function (error) {
  
					  currentObj.output = error;
  
				  });
  
			  },
              
              ///////////////////////////////////////
              
              
     /*************************** Payslip creation modal functions **************/
              
              
			  getEmployeesnewpayslip: function()
			  {
  
                     axios.get(this.$api_url+'/remainingemployees/'+this.prun_id_np , {
							  params: {
								  page: 1,

							  }
					  }).then(function(response){
					   
                       //console.log(response.data.employees); 
					   
					  this.employees_np = response.data.employees;
  
  
				  }.bind(this));
			  },
			  
 
  
 
 			  newpaysligformSubmit: function(e)
			  {
                       e.preventDefault();
                       this.new_payslip_loading=1;
                     axios.get(this.$api_url+'/createpayslipbyid/'+this.prun_id_np+'/'+this.employee_np , {
							  params: {
								  page: 1,

							  }
					  }).then(function(response){
					   
                       //alert(1);
					   
                       //console.log(response.data.success); 
                      this.modalsuccess = response.data.success;
                      this.getPayrunPayslips();
                      this.sortBy('employee_name');
                      this.$bvModal.hide('new_payslip_modal');
                      this.new_payslip_loading='';
  
				  }.bind(this));
			  },

              
    /************************************************************************/           
              
              
			// Faroque code starts here
			exportAll: function()
            {
                this.$bvToast.toast('It might take a while', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });
                this.download_loader = true;
                this.download_text = 'Please hold tight. We are exporting the template for you.';
                axios.get(this.$api_url+'/payrun/export/'+this.fdata.id)
                    .then(function (response) { 
                        this.download_loader = false;   
                        window.location.href= response.data;  
                        this.download_text = '';                
                        //window.open(response.data);
                    }.bind(this));
            },
			importAll: function()
			{
				//this.upload_all = true;
				document.getElementById('datafile').click();
               
			},
			uploadFile:function(event) 
            {
                this.emgfile = event.target.files[0];
                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('emgfile', this.emgfile);
                
                this.$bvToast.toast('We are uploading the excel and will initiate the import process accordingly.', {title: 'Uploading!',variant: 'success',solid: true});

                axios.post(this.$api_url+'/payrun/import/uploadfile/'+this.fdata.id, data , config).
                    then(function (response){

                        
                                        
                        this.download_loader = true;  
                        this.download_text = 'We are importing the excel file and will process the calculation accordingly. This may take some time.';                      
                    
                        this.processFileData();
                        
                    }.bind(this)).
                    catch(function (error) 
                            {
                                //alert(error.response.data.errors);
                            });
            },
            processFileData:function()
            {
                
                axios.get(this.$api_url+'/payrun/import/process/'+this.fdata.id)
                .then(function (response) {                
                        
                        if(response.data.status)
                        { 
                             this.download_loader = false; 
                             this.download_text = ''; 
                            
                            if(response.data.status=="File Imported Successfully") 
                            {
                             this.$bvToast.toast(response.data.status, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                            }
                          
                            
                             
                            if(response.data.status=="File Imported Successfully")           
                            window.location.href = window.location;
                            else
                            {
                                this.$bvToast.toast(response.data.status, {
                                            title: `Import Failed`,
                                            variant: 'danger',
                                            solid: true
                                        });
                            }
                            //alert(response.data.status);
                                        
                                           
                        }
                        else
                        {
                            this.errormsg = response.data.errors;
                        }

                     
                        
                }.bind(this));
            },
            
            
              failed_request_recovery: function()
			  {
			       if(this.payslip_loading==1)
                   {
                      this.getPayrunPayslips();
                      this.sortBy('employee_name');
                   }
			  },


			
			
			
			// Faroque code ends here
            get_decimal_settings: function()
              {
                  axios.get(this.$api_url+'/decimal-settings')
  
				  .then(function (response) {
				    this.decimal_setting = response.data;  
				  }.bind(this));
              },
            sumTotals: function(value1, value2)
              {
                let sum = 0;
                let val1 = value1.replace(/\,/g,'');
                let val2 = value2.replace(/\,/g,'');
                sum = (parseFloat(val1) + parseFloat(val2)).toFixed(2);
                if(this.decimal_setting == 'no'){
                    //sum = (parseInt(val1) + parseInt(val2));
                    sum = Math.round(sum);
                }else{
                    sum = sum;                    
                }
                sum = sum.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                return sum;
              },
              
              deductTax: function(value1, value2)
              {
                let sum = 0;
                let val1 = value1.replace(/\,/g,'');
                let val2 = value2.replace(/\,/g,'');
                sum = (parseFloat(val1) - parseFloat(val2)).toFixed(2);
                if(this.decimal_setting == 'no'){
                    //sum = (parseInt(val1) - parseInt(val2));
                    sum = Math.round(sum);
                }else{
                    sum = sum;                    
                }
                sum = sum.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                return sum;
              },
              
              /** custom fields **/
              
            listReturn:function(data)
            {
                console.log(data);
                if(data.selected.length > 0)
                {
                    this.payslipids = data.selected;
                }else if(data.column_selected.length > 0)
                {
                    this.column_selected = data.column_selected;
                }else{
                    this.payslipids = [];
                    if(data.action_id==1)
                    {
                        this.custom_list.forEach(element => {
                            if(element.id == data.id){
                                this.displaymodal(element.id, element.employee_id, element.fiscal_year, element.from_date, element.to_date, element.pay_slip_ref, element.pay_slip_name, element.employee_name, element.pic, element.position, element.ait, element.medical_reimbursement);
                            }
                        });
                    }
                    else if(data.action_id==2)
                    {
                        this.displaytaxcardmodal(data.id);
                    }
                    else if(data.id > 0)
                    {
                        this.custom_list.forEach(element => {
                            if(element.id == data.id){
                                this.displaymodal(element.id, element.employee_id, element.fiscal_year, element.from_date, element.to_date, element.pay_slip_ref, element.pay_slip_name, element.employee_name, element.pic, element.position, element.ait, element.medical_reimbursement);
                            }
                        });
                    }
                }             

            },
              /** custom fields **/
              
            getPayrunUserdata: function(payrun_id)
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/get-payrun-userdata/?payrun_id='+payrun_id , {

                }).then(function(response){
                    this.payrun_userdata = response.data;

                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            
            getSalaryReport: function(year,month)
            {
                if(!this.checkNet()) return false;
                this.loader = true;
                this.download_loader = true;
                this.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';
                if(this.column_selected.indexOf('name') === -1){
                    this.column_selected.unshift('name');
                }
                let currentObj = this;
                let formData = new FormData();
                formData.append('year', year);
                formData.append('month', month);
                formData.append('grid_report', 'Excel');
                formData.append('column_selected', this.column_selected);
                formData.append('report', 1);
                let url = this.$api_url + '/payroll_monthly_report_custom';
                axios.post(url, formData).then(function (response) 
                { 
                    //this.payroll_reporting_data = response.data;
                    //var fileURL = this.$api_url+'/payroll_monthly_report?grid_report=Excel&year='+year+'&month='+month;
                    this.download_file(response.data);
                    this.loader = false;
                    this.download_loader = false; 
                    this.download_text = '';
                    
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
                return false;
            },
            
            download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            
   
  
		  },
		  created: function(){
		      this.getEmployees();
              this.getpayrunsfiscalyear();
			  //this.getPayrunPayslips();
			  //alert(this.fdata.id);
			  this.search_by_id.payrun=this.fdata.id;
               this.prun_id_np=this.fdata.id;
               this.getEmployeesnewpayslip();
               //this.getCustomList();
              // setInterval(this.failed_request_recovery, 9000);
		
        /** Following line added by Faroque */
        this.getPayrunPayslips();
        this.get_decimal_settings();
        this.getPayrunUserdata(this.fdata.id);

        this.fdata.name = this.fdata.name.replace("Payroll Run", "Gratuity Fund Run");
      
      },
        computed: 
         {
            filteredData() 
            {
                let filtered_list = this.employees_np;
                if (this.this_search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.this_search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                            this.blankmsg = "Nothing found.";
                }
                
                return filtered_list;
            },
            paginatedData() 
            {     
                this.backdoor;
                
                return this.paginate(this.filteredData, this.length, this.this_pagination.currentPage);
            },

         }
	  }
  </script>

  <style>
.trz_ppl_wrapper {
	position: static;
}
.trz_ppl_wrapper_2 {
	position: static;
}
.demolistwrap {
	position: static !important;
}
.demolistwrap2 {
	position: static !important;
}
.trz_people_btn {
	right: 0;
	top: -37px;
}
</style>